// Internationalization configuration
// Supports: English (en), French (fr), German (de)

import { sellFlow } from './sellFlow';

export const translations = {
  en: {
    "messages.viewProfile": "View profile",
    "header.savedSearches": "Saved searches",
    "saved.kicker": "Your alerts",
    "saved.title": "Saved searches",
    "saved.subtitle": "We watch the market for you: new listings that match show up here and in your inbox.",
    "saved.count": "{n} saved",
    "saved.totalNew": "{n} new listings since your last visit",
    "saved.new": "{n} new",
    "saved.noNew": "Nothing new",
    "saved.freq.instant": "Instant",
    "saved.freq.daily": "Daily digest",
    "saved.freq.off": "Off",
    "saved.freq.instantHint": "Email as soon as a new listing matches (max one per hour)",
    "saved.freq.dailyHint": "One summary email every morning at 08:00",
    "saved.freq.offHint": "No emails, only the badge on this page",
    "saved.view": "View results",
    "saved.rename": "Rename",
    "saved.delete": "Delete",
    "saved.deleteTitle": "Delete this saved search?",
    "saved.deleteText": "You will stop receiving alerts for “{name}”.",
    "saved.cancel": "Cancel",
    "saved.empty": "No saved searches yet",
    "saved.emptyText": "Run a search, tap “Save search”, and we will let you know when something new matches.",
    "saved.startSearching": "Start searching",
    "saved.newSearch": "New search",
    "saved.updated": "Saved search updated",
    "saved.deleted": "Saved search deleted",
    "saved.failed": "Something went wrong, please try again",
    "saved.allListings": "All listings",
    "saved.upTo": "Up to €{n}",
    "saved.from": "From €{n}",
    "saved.manage": "Manage saved searches",
    "saved.signIn": "Sign in to see your saved searches",
    "home.latest.forYou": "Recommended for you",
    "feed.notInterested": "Not interested",
    "feed.hidden": "We'll show fewer listings like this.",
    "feed.undo": "Undo",
    "feed.why.similar_to_favourites": "Similar to items you liked",
    "feed.why.viewed_subcategory": "Because you looked at similar items",
    "feed.why.favourite_category": "From a category you follow",
    "feed.why.near_you": "Near you",
    "feed.why.new_and_popular": "New and popular",
    "feed.why.explore": "Something different",
    "profile.personalization": "Personalised recommendations",
    "profile.personalizationHint": "Use my views, favourites, searches and messages to rank the homepage for me. Off = the same feed everyone sees.",
    "profile.clearHistory": "Clear my recommendation history",
    "phoneVerify.badgeHint": "This member confirmed control of a mobile number by SMS code. It is not an identity check and does not guarantee a transaction.",
    "phoneVerify.title": "Verify your phone number",
    "phoneVerify.subtitle": "To keep LebonLux safe, every member confirms a mobile number once before messaging. We only send a code by SMS — your number stays private.",
    "phoneVerify.phoneLabel": "Mobile number",
    "phoneVerify.sendCode": "Send code",
    "phoneVerify.sending": "Sending…",
    "phoneVerify.codeSentTo": "We sent a 6-digit code to",
    "phoneVerify.codeLabel": "Enter the code",
    "phoneVerify.verify": "Verify",
    "phoneVerify.verifying": "Verifying…",
    "phoneVerify.resend": "Resend code",
    "phoneVerify.resendIn": "Resend in {s}s",
    "phoneVerify.changeNumber": "Change number",
    "phoneVerify.successTitle": "Phone verified",
    "phoneVerify.successText": "Thanks! You can now message buyers and sellers.",
    "phoneVerify.continue": "Continue",
    "phoneVerify.required": "Please verify your phone number to send messages.",
    "phoneVerify.mockHint": "Test mode: use code 123456",
    "phoneVerify.verifyButton": "Verify my phone",
    "phoneVerify.verifiedLabel": "Phone verified",
    "phoneVerify.notVerifiedLabel": "Phone not verified",
    "phoneVerify.err.invalid_phone": "This phone number is not valid.",
    "phoneVerify.err.country_not_allowed": "Only numbers from Luxembourg, France, Belgium, Germany, Portugal, Italy and Spain are accepted.",
    "phoneVerify.err.mobile_required": "Please use a mobile number.",
    "phoneVerify.err.phone_already_used": "This number is already verified on another account.",
    "phoneVerify.err.incorrect_code": "Incorrect code. {n} attempts left.",
    "phoneVerify.err.expired": "This code has expired. Request a new one.",
    "phoneVerify.err.attempts_exhausted": "Too many attempts. Request a new code.",
    "phoneVerify.err.resend_cooldown": "Please wait a moment before requesting a new code.",
    "phoneVerify.err.provider_error": "We couldn't send the SMS right now. Please try again shortly.",
    "phoneVerify.err.generic": "Something went wrong. Please try again.",
    "profile.standard": "Standard",
    "category.byCity": "Browse by city",
    "home.latest.discover": "Recommended",
    "filters.moreCriteria": "More criteria ({count})",
    "filters.lessCriteria": "Fewer criteria",
    "auth.register.err.emailExists": "This email is already registered. Try logging in instead.",
    "edit.title": "Edit Listing",
    "edit.basicDetails": "Basic Details",
    "edit.saving": "Saving...",
    "edit.success": "Listing updated successfully!",
    "edit.err.load": "Failed to load listing",
    "edit.err.update": "Failed to update listing. Please try again.",
    "auth.register.subtitle": "Create an account to start buying and selling.",
    "auth.register.passwordPlaceholder": "Create a password",
    "auth.register.req.length": "At least 8 characters",
    "auth.register.req.upper": "One uppercase letter",
    "auth.register.req.number": "One number",
    "auth.register.err.terms": "Please accept the terms and conditions",
    "auth.register.err.password": "Please meet all password requirements",
    "auth.register.err.failed": "Registration failed. Please try again.",
    "auth.register.err.google": "Google sign up failed",
    "auth.register.agree": "I agree to the",
    "auth.register.termsLink": "Terms of Service",
    "auth.register.and": "and",
    "auth.register.privacyLink": "Privacy Policy",
    "auth.register.creating": "Creating account...",
    "auth.login.err.invalid": "Invalid email or password",
    "auth.login.err.google": "Google login failed",
    "listing.ownerActions": "Manage your listing",
    "myListings.actions.markSold": "Mark as sold",
    "myListings.actions.reactivate": "Reactivate",
    "myListings.views": "views",
    "myListings.sold.title": "Mark as sold?",
    "myListings.sold.text": "\"{title}\" will be shown as sold. Conversations without an accepted offer will be closed. You can reactivate it later.",
    "myListings.toast.sold": "Listing marked as sold",
    "myListings.toast.deleted": "Listing deleted",
    "myListings.toast.reactivated": "Listing reactivated",
    "myListings.toast.failed": "Action failed, please try again",
    // Header
    "header.categories": "Categories",
    "header.searchPlaceholder": "Search for items...",
    "header.login": "Log in",
    "header.signup": "Sign up",
    "header.sell": "Sell",
    "header.favorites": "Favorites",
    "header.messages": "Messages",
    "header.myListings": "My Listings",
    "header.profile": "Profile",
    "header.logout": "Logout",
    "header.tagline": "Luxembourg & Beyond | Buy & sell locally within 200km",
    
    // Navigation
    "nav.categories": "Categories",
    "nav.sell": "Sell an item",
    "nav.logout": "Log out",
    "nav.myProfile": "My Profile",
    "nav.myListings": "My Listings",
    "nav.favorites": "Favorites",
    "nav.messages": "Messages",
    "nav.login": "Log in",
    "nav.signup": "Sign up",
    "cond.new-with-tags": "New with tags",
    "cond.excellent": "Excellent",
    "cond.very-good": "Very good",
    "cond.used": "Used",
    "filters.details": "Details",
    "filters.min": "Min",
    "filters.max": "Max",
    "filters.priceRange": "Price",
    "filters.anyCondition": "Any condition",
    "profile.tabSaved": "Saved listings",
    "profile.tabSearches": "Saved searches",
    "profile.tabSettings": "Settings",
    "messages.sendFailed": "Your message could not be sent. Please try again.",
    "messages.searchPlaceholder": "Search conversations…",
    "messages.markAllRead": "Mark all read",
    "filters.category": "Category",
    "filters.allCategories": "All categories",
    "filters.subcategory": "Subcategory",
    "filters.allSubcategories": "All subcategories",
    "filters.condition": "Condition",
    "filters.location": "Location",
    "filters.yourLocation": "Your location",
    "filters.transaction": "Transaction type",
    "filters.saleOrRent": "Sale or rent",
    "filters.any": "Any",
    "filters.forSale": "For sale",
    "filters.forRent": "For rent",
    "filters.realEstate": "Real estate filters",
    "filters.vehicles": "Vehicle filters",
    "filters.surface": "Surface (m²)",
    "filters.minRooms": "Min. rooms",
    "filters.brand": "Brand",
    "filters.anyBrand": "Any brand",
    "filters.year": "Year (from)",
    "filters.anyYear": "Any year",
    "filters.mileage": "Max. mileage",
    "filters.anyMileage": "Any mileage",
    "filters.fuel": "Fuel type",
    "filters.anyFuel": "Any fuel",
    "filters.search": "Search",
    "filters.saveSearch": "Save search",
    "filters.saveFailed": "Failed to save search. Please try again.",
    "filters.list": "List",
    "filters.map": "Map",
    "filters.searchName": "Search name",
    "filters.searchNamePlaceholder": "e.g. Apartments under €1,500",
    "filters.emailAlerts": "Email alerts",
    "filters.emailAlertsHint": "Get notified when new listings match",
    "cond.new": "New",
    "cond.like-new": "Like new",
    "cond.good": "Good",
    "cond.fair": "Fair",
    "cond.poor": "Poor",
    "category.notFound": "Category not found",
    "category.notFoundText": "This category doesn't exist.",
    "category.backHome": "Back to home",
    "category.empty": "No listings found in this category",
    "myListings.signIn": "Sign in to view your listings",
    "myListings.signInText": "Manage all your listings in one place",
    "myListings.shipping": "Shipping",
    "auth.signIn": "Sign in",
    "footer.serving": "Serving:",
    "footer.howItWorks": "How it works",
    "footer.faq": "FAQ",
    "footer.aboutUs": "About us",
    "footer.careers": "Careers",
    "country.luxembourg": "Luxembourg",
    "country.germany": "Germany",
    "country.france": "France",
    "country.belgium": "Belgium",
    "profile.logout": "Log out",
    "profile.noSaved": "No saved listings yet",
    "profile.noSavedText": "Save listings by tapping the heart icon",
    "profile.noSearches": "No saved searches yet",
    "profile.notifications": "Notification settings",
    "profile.notificationsText": "Manage how you receive notifications",
    "profile.emailNotifications": "Email notifications",
    "profile.accountInfo": "Account information",
    "profile.accountInfoText": "Your account details",
    "profile.email": "Email",
    "profile.accountStatus": "Account status",
    "explore.savedSearches": "Your saved searches",
    "search.trending": "Popular searches",
    "search.recentlyViewed": "Recently viewed",
    "search.clearRecent": "Clear",
    "messages.repliesIn": "Replies in {time}",
    "messages.replyRateShort": "{rate}% reply rate",
    "messages.memberSince": "Member since {date}",
    "nav.allCategories": "All categories",
    "nav.admin": "Admin",
    "browser.viewAll": "See everything in {name}",
    "browser.ads": "ads",
    "browser.ad": "ad",
    
    // Homepage
    "home.hero.title": "Buy & Sell in",
    "home.hero.highlight": "Luxembourg & Beyond",
    "home.hero.subtitle": "Buy and sell locally in Luxembourg and nearby towns. Free listings, browsing in 4 languages, hand-to-hand collection.",
    "home.search.placeholder": "What are you looking for?",
    "home.search.allLocations": "All locations",
    "home.search.button": "Search",
    "home.search.minPrice": "Min €",
    "home.search.maxPrice": "Max €",
    "home.search.filters": "Filters",
    "home.search.advanced": "Advanced search",
    "home.search.clearFilters": "Clear Filters",
    "home.search.applyFilters": "Apply Filters",
    "home.search.clearAll": "Clear all",
    "home.search.filterBy": "Filter by",
    "home.search.selectOption": "Select",
    "home.search.all": "All",
    "home.search.results": "results",
    "home.search.resultsIn": "in",
    "home.popular": "Popular:",
    
    // Map Search
    "mapSearch.title": "Real Estate Search",
    "mapSearch.propertiesFound": "properties found",
    "mapSearch.onMap": "on map",
    "mapSearch.map": "Map",
    "mapSearch.list": "List",
    "mapSearch.filters": "Filters",
    "mapSearch.listingType": "Listing Type",
    "mapSearch.propertyType": "Property Type",
    "mapSearch.price": "Price",
    "mapSearch.minRooms": "Minimum rooms",
    "mapSearch.all": "All",
    "mapSearch.forSale": "For Sale",
    "mapSearch.forRent": "For Rent",
    "mapSearch.anyRooms": "Any",
    "mapSearch.resetFilters": "Reset filters",
    "mapSearch.viewListing": "View listing",
    "mapSearch.noProperties": "No properties found",
    "common.loading": "Loading...",
    
    "home.cta.title": "It's time to sell!",
    "home.cta.subtitle": "Post your ad for free and reach thousands of buyers",
    "home.cta.button": "Post an ad",
    "home.noResults.title": "No listings found",
    "home.noResults.subtitle": "No listings match your criteria",
    "home.noResults.beFirst": "Be the first to post a listing!",
    "home.stats.listings": "Active listings",
    "home.stats.users": "Registered members",
    "home.stats.countries": "Countries",
    "home.mapSearch": "Map Search",
    "home.viewOnMap": "View on Map",
    "home.map": "Map",
    "home.categories.title": "Browse by Category",
    "home.categories.viewAll": "View all",
    "home.featured.title": "Featured Listings",
    "home.featured.seeAll": "See all",
    "home.latest.title": "Recommended listings",
    "home.latest.category": "Category",
    "home.latest.newest": "Newest first",
    "home.latest.priceLow": "Price: Low to High",
    "home.latest.priceHigh": "Price: High to Low",
    "home.latest.popular": "Most popular",
    "home.latest.loadMore": "Load more listings",
    "home.latest.noListings": "No listings found",
    "home.latest.createFirst": "Create the first listing",
    "home.why.title": "Why Choose LebonLux?",
    "home.why.verified.title": "Verified Sellers",
    "home.why.verified.desc": "Buy with confidence from verified sellers with ratings and reviews.",
    "home.why.local.title": "Local & Cross-Border",
    "home.why.local.desc": "Find deals in Luxembourg and neighboring regions across 4 countries.",
    "home.why.ai.title": "AI-Powered Listings",
    "home.why.ai.desc": "Sell faster with automatic categorization and smart pricing suggestions.",
    
    // Categories - Unified with Leboncoin
    "category.vehicules": "Vehicles",
    "category.immobilier": "Real Estate",
    "category.vacances": "Holiday Rentals",
    "category.emploi": "Jobs",
    "category.mode": "Fashion",
    "category.maison-jardin": "Home & Garden",
    "category.famille": "Family",
    "category.electronique": "Electronics",
    "category.loisirs": "Leisure",
    "category.services": "Services",
    "category.materiel-pro": "Professional Equipment",
    "category.art": "Art",
    "category.autres": "Other",
    "category.ads": "ads",
    "category.listingsFound": "{count} listings found",
    "category.noListingsFound": "No listings found in this category",
    "category.loadMore": "Load more listings",
    "category.all": "All",
    "category.allConditions": "All conditions",
    "category.condition": "Condition",
    "category.filters": "Filters",
    "category.clearAll": "Clear all",
    "category.clearAllFilters": "Clear all filters",
    "category.clearFilters": "Clear filters",
    "sort.newest": "Newest first",
    "sort.priceLow": "Price: Low to High",
    "sort.priceHigh": "Price: High to Low",
    "sort.popular": "Most popular",
    "sort.oldest": "Oldest first",
    "sort.label": "Sort by",
    "followup.label": "Quick check-in",
    "followup.yes": "Yes, still interested",
    "followup.no": "No thanks",
    "followup.answeredYes": "You replied: still interested 👍",
    "followup.answeredNo": "You replied: no longer interested",
    "followup.sellerHint": "We asked the buyer whether they are still interested.",
    "sold.prompt.title": "Offer accepted!",
    "sold.prompt.description": "Mark “{title}” as sold? Other buyers will be told the item is gone and this chat stays open to arrange the handover.",
    "sold.prompt.hint": "The listing stays visible for 30 days with a “Sold” badge.",
    "sold.prompt.confirm": "Mark as sold",
    "sold.prompt.later": "Later",
    "sold.prompt.done": "Listing marked as sold 🎉",
    "sold.banner.text": "You accepted an offer for “{title}”.",
    "sold.banner.cta": "Mark as sold",
    "listing.sold": "Sold",
    "messages.closedSold": "Conversation closed — the listing was sold",
    "safety.nudge": "Stay safe: meet in a public place, pay only when you have the item, never send a deposit or pay outside LebonLux.",
    
    // Create Listing
    "create.title": "Create Listing",
    "create.step.photos": "Photos",
    "create.step.details": "Details",
    "create.step.price": "Price & Location",
    "create.step.confirm": "Confirm",
    "create.photos.title": "Add Photos",
    "create.photos.subtitle": "Add up to 10 photos. The first photo will be the cover.",
    "create.photos.upload": "Click to upload photos",
    "create.photos.dragDrop": "or drag and drop",
    "create.photos.cover": "Cover",
    "create.photos.optional": "Photos are optional - you can add them later",
    "create.photos.skipAI": "Skip and categorize manually",
    "create.ai.title": "AI-Powered Auto-Fill",
    "create.ai.subtitle": "Let our AI analyze your photos to automatically suggest category, title, description, and price.",
    "create.ai.analyze": "Analyze Photos",
    "create.ai.analyzing": "Analyzing...",
    "create.ai.category": "Suggested category",
    "create.ai.titleSuggestion": "Suggested title",
    "create.ai.retailValue": "Estimated retail value (new)",
    "create.ai.suggestedPrice": "Suggested selling price",
    "create.ai.confidence": "Confidence",
    "create.ai.apply": "Apply Suggestions",
    "create.ai.suggestPrice": "AI Price",
    "create.ai.calculating": "Calculating...",
    "create.ai.suggestedRange": "AI Suggested Range",
    "create.ai.priceError": "Please fill in title, category, and condition first",
    "create.ai.priceSuggestionFailed": "Could not get AI price suggestion. Please enter price manually.",
    "create.details.title": "Item Details",
    "create.details.subtitle": "Tell buyers about your item.",
    "create.details.itemTitle": "Title",
    "create.details.titlePlaceholder": "e.g., iPhone 14 Pro - Excellent Condition",
    "create.details.description": "Description",
    "create.details.descPlaceholder": "Describe your item - include condition, features, reason for selling...",
    "create.details.category": "Category",
    "create.details.selectCategory": "Select category",
    "create.details.subcategory": "Subcategory",
    "create.details.selectSubcategory": "Select subcategory",
    "create.details.condition": "Condition",
    "create.details.selectCondition": "Select condition",
    "create.details.attributes": "Additional Details",
    "create.price.title": "Price & Location",
    "create.price.subtitle": "Set your price and confirm your location.",
    "create.price.type": "Price Type",
    "create.price.fixed": "Fixed",
    "create.price.negotiable": "Negotiable",
    "create.price.free": "Free",
    "create.price.amount": "Price (€)",
    "create.price.retailHint": "Retail value: €{value}",
    "create.location.title": "Location",
    "create.location.select": "Select your location",
    "create.location.change": "Change",
    "create.shipping.title": "Shipping available",
    "create.shipping.subtitle": "Offer to ship this item to buyers",
    "create.preview": "Preview",
    "create.preview.title": "Your listing title",
    "create.preview.selectLocation": "Select location",
    "create.nav.back": "Back",
    "create.nav.continue": "Continue",
    "create.nav.publish": "Publish Listing",
    "create.nav.publishing": "Publishing...",
    "create.location.popup.title": "Where are you located?",
    "create.location.popup.detect": "Use my current location",
    "create.location.popup.detecting": "Detecting location...",
    "create.location.popup.manual": "Or enter manually",
    "create.location.popup.search": "Search city or town...",
    "create.location.popup.hint": "We serve Luxembourg and surrounding regions within 200km",
    
    // Confirm Step
    "create.confirm.title": "Review Your Listing",
    "create.confirm.subtitle": "Please review all details before publishing. You can edit any field.",
    "create.confirm.noPhotos": "No photos added",
    "create.confirm.editPhotos": "Edit photos",
    "create.confirm.preview": "Listing Preview",
    
    // My Listings
    "myListings.title": "My Listings",
    "myListings.count": "{count} active listings",
    "myListings.newListing": "New Listing",
    "myListings.empty.title": "No listings yet",
    "myListings.empty.subtitle": "Start selling by creating your first listing",
    "myListings.empty.button": "Create Your First Listing",
    "myListings.actions.view": "View",
    "myListings.actions.edit": "Edit",
    "myListings.actions.delete": "Delete",
    "myListings.delete.title": "Delete Listing",
    "myListings.delete.whyDelete": "Why are you deleting this listing?",
    "myListings.delete.confirm": "Are you sure you want to delete \"{title}\"? This action cannot be undone.",
    "myListings.delete.cancel": "Cancel",
    "myListings.delete.deleting": "Deleting...",
    "myListings.delete.markingSold": "Marking as sold...",
    "myListings.delete.markSold": "Mark as Sold",
    "myListings.delete.otherPlaceholder": "Please specify your reason...",
    "myListings.delete.congrats": "Congratulations on your sale! Your listing will be marked as SOLD and remain visible to others as social proof. All conversations will be closed.",
    "myListings.deleteReason.soldHere": "Sold on LebonLux",
    "myListings.deleteReason.soldElsewhere": "Sold elsewhere",
    "myListings.deleteReason.noLongerSelling": "No longer want to sell",
    "myListings.deleteReason.other": "Other reason",
    
    // Favorites
    "favorites.title": "My Favorites",
    "favorites.savedItems": "saved items",
    "favorites.signIn": "Sign in to view favorites",
    "favorites.signInSubtitle": "Save items you love and come back to them anytime",
    "favorites.empty": "No favorites yet",
    "favorites.emptySubtitle": "Start saving items you love by clicking the heart icon",
    "favorites.browse": "Browse Listings",
    
    // Profile
    "profile.signInRequired": "Sign in to view your profile",
    "profile.editProfile": "Edit Profile",
    "profile.verified": "Phone verified",
    "profile.basicInfo": "Basic Information",
    "profile.name": "Name",
    "profile.phone": "Phone Number",
    "search.noResultsFor": "No results for “{q}”",
    "search.noListings": "No listings",
    "search.tryDifferent": "Try different keywords or filters",
    "search.clearFilters": "Clear filters",
    "search.searching": "Searching…",
    "search.items": "{n} items",
    "badge.new": "New",
    "badge.priceDrop": "Price drop",
    "badge.shipping": "Delivery possible",
    "badge.saves": "{n} saved",
    "badge.savesLong": "{n} people saved this listing",
    "alerts.title": "Few results? Get notified",
    "alerts.text": "We will email you as soon as a new listing matches this search.",
    "alerts.cta": "Create an alert",
    "alerts.created": "Alert created — we will email you about new matches",
    "alerts.exists": "You already have an alert for this search",
    "alerts.manage": "Manage my alerts",
    "alerts.login": "Log in to create an alert — your search is saved",
    "profile.replyRate": "Reply rate",
    "profile.replyTime": "Replies in",
    "profile.stats.sold": "Sold",
    "buyer.contact": "Contact seller",
    "buyer.contactPrice": "Contact seller • {price}",
    "buyer.send": "Send message",
    "buyer.dialogTitle": "Message the seller",
    "buyer.messagePlaceholder": "Hello, is this item still available?",
    "buyer.quick.available": "Still available?",
    "buyer.quick.lastPrice": "Best price?",
    "buyer.quick.visit": "Can I come and see it?",
    "buyer.quick.delivery": "Do you deliver?",
    "buyer.offer.cta": "Make an offer",
    "buyer.offer.title": "Your offer",
    "buyer.offer.hint": "The seller can accept or decline in the chat.",
    "buyer.offer.send": "Send offer of {amount} €",
    "buyer.offer.accept": "Accept",
    "buyer.offer.decline": "Decline",
    "buyer.offer.pending": "Offer pending",
    "buyer.offer.accepted": "Offer accepted",
    "buyer.offer.declined": "Offer declined",
    "buyer.offer.yours": "Your offer",
    "buyer.sentToast": "Message sent — the seller has been notified",
    "buyer.savedDraft": "Log in to send your message — we kept it for you",
    "buyer.seller.replyRate": "Reply rate",
    "buyer.seller.replyTime": "Replies in",
    "buyer.seller.listings": "Listings",
    "buyer.seller.memberSince": "Member since {date}",
    "buyer.seller.call": "Call the seller",
    "buyer.seller.replyMinutes": "~{n} min",
    "buyer.seller.replyHours": "~{n} h",
    "buyer.seller.replyDays": "~{n} d",
    "buyer.seller.safety": "Meet in a public place and pay only once you have the item in hand. Never send a deposit.",
    "auth.sheet.title": "Log in to continue",
    "auth.sheet.description": "Takes 10 seconds. Your message is saved and will be sent right after.",
    "auth.sheet.google": "Continue with Google",
    "auth.sheet.emailPlaceholder": "Your email",
    "auth.sheet.passwordPlaceholder": "Password",
    "auth.sheet.magic": "Send me a login link",
    "auth.sheet.login": "Log in",
    "auth.sheet.usePassword": "I have a password",
    "auth.sheet.useMagic": "Log in without password instead",
    "auth.sheet.magicSentTitle": "Check your inbox",
    "auth.sheet.magicSentText": "We sent a login link to {email}. Open it on this phone to continue.",
    "auth.sheet.noAccountHint": "No account yet? It is created automatically.",
    "auth.sheet.error": "Something went wrong, please try again",
    "nav.home": "Home",
    "nav.search": "Search",
    "nav.sell": "Sell",
    "nav.messages": "Messages",
    "nav.profile": "Profile",
    "nav.login": "Log in",
    "card.noPhoto": "No photo",
    "filters.title": "Filters",
    "filters.priceRange": "Price range (€)",
    "filters.anyCondition": "Any condition",
    "filters.includeSold": "Include sold items",
    "filters.nearMe": "Listings near me",
    "filters.locating": "Finding your location…",
    "filters.show": "Show {n} results",
    "filters.searchPlaceholder": "Search…",
    "filters.allListings": "All listings",
    "filters.newest": "Newest first",
    "filters.cityPlaceholder": "City or town…",
    "messages.typePlaceholder": "Write a message…",
    "messages.makeOffer": "Make an offer",
    "messages.viewListing": "View listing",
    "profile.saved": "Profile updated",
    "profile.saveFailed": "Could not save your profile",
    "profile.showPhonePublic": "Show phone number on my listings",
    "profile.bio": "About Me",
    "profile.bioPlaceholder": "Tell others about yourself...",
    "profile.location": "Location",
    "profile.city": "City",
    "profile.country": "Country",
    "profile.professionalAccount": "Professional Account",
    "profile.companyName": "Company Name",
    "profile.siret": "SIRET Number",
    "profile.website": "Website",
    "profile.responseTime": "Response Time",
    "profile.selectResponseTime": "Select your typical response time",
    "profile.notSpecified": "Not specified",
    "profile.responseTime.1hour": "Less than 1 hour",
    "profile.responseTime.24hours": "Less than 24 hours",
    "profile.responseTime.2days": "1-2 days",
    "profile.responseTime.moreDays": "More than 2 days",
    "profile.memberSince": "Member since",
    "profile.responds": "Responds in",
    "profile.visitWebsite": "Visit website",
    "profile.listings": "Listings",
    "profile.reviews": "reviews",
    "profile.responseRate": "Response rate",
    "profile.myListings": "My Listings",
    "profile.reviewsTab": "Reviews",
    "profile.newListing": "New Listing",
    "profile.noListings": "No listings yet",
    "profile.noListingsDesc": "Start selling by creating your first listing",
    "profile.createListing": "Create Listing",
    "profile.noReviews": "No reviews yet",
    "profile.noReviewsDesc": "Reviews will appear here once buyers leave feedback",
    "profile.reviewsComingSoon": "Reviews feature coming soon",
    "profile.lastActive.unknown": "Last seen recently",
    "profile.lastActive.now": "Online now",
    "profile.lastActive.hoursAgo": "Last seen",
    "profile.lastActive.yesterday": "Last seen yesterday",
    "profile.lastActive.daysAgo": "Last seen",
    
    // Common
    "common.cancel": "Cancel",
    "common.saving": "Saving...",
    "common.saveChanges": "Save Changes",
    
    // Messages
    "messages.title": "Messages",
    "messages.search": "Search conversations...",
    "messages.signIn": "Sign in to view messages",
    "messages.noConversations": "No conversations yet",
    "messages.startConversation": "Start a conversation by contacting a seller",
    "messages.selectConversation": "Select a conversation",
    "messages.chooseConversation": "Choose from your existing conversations or start a new one",
    "messages.usuallyResponds": "Usually responds within an hour",
    "messages.report": "Report",
    "messages.deleteConversation": "Delete conversation",
    "messages.typePlaceholder": "Type a message...",
    "messages.attachFile": "Attach file",
    "messages.attachImage": "Attach image",
    
    // Auth
    "auth.login.title": "Welcome back! Sign in to continue.",
    "auth.login.google": "Continue with Google",
    "auth.login.or": "or",
    "auth.login.email": "Email",
    "auth.login.emailPlaceholder": "your@email.com",
    "auth.login.password": "Password",
    "auth.login.forgot": "Forgot password?",
    "auth.login.button": "Sign In",
    "auth.login.noAccount": "Don't have an account?",
    "auth.login.signup": "Sign up",
    "auth.register.title": "Create your account",
    "auth.register.name": "Full Name",
    "auth.register.namePlaceholder": "John Doe",
    "auth.register.button": "Create Account",
    "auth.register.hasAccount": "Already have an account?",
    "auth.register.login": "Sign in",
    "auth.register.terms": "By signing up, you agree to our Terms and Privacy Policy",
    "auth.email": "Email",
    "auth.emailPlaceholder": "your@email.com",
    
    // Forgot Password
    "forgot.title": "Forgot Password?",
    "forgot.subtitle": "Enter your email and we'll send you a link to reset your password.",
    "forgot.sendLink": "Send Reset Link",
    "forgot.sending": "Sending...",
    "forgot.backToLogin": "Back to Login",
    "forgot.success.title": "Check Your Email",
    "forgot.success.message": "If an account exists with that email, we've sent you a password reset link.",
    "forgot.success.checkSpam": "Don't see it? Check your spam folder.",
    
    // Reset Password
    "reset.title": "Reset Password",
    "reset.subtitle": "Enter your new password for",
    "reset.newPassword": "New Password",
    "reset.newPasswordPlaceholder": "Enter new password",
    "reset.confirmPassword": "Confirm Password",
    "reset.confirmPasswordPlaceholder": "Confirm new password",
    "reset.resetButton": "Reset Password",
    "reset.resetting": "Resetting...",
    "reset.verifying": "Verifying reset link...",
    "reset.passwordMismatch": "Passwords do not match",
    "reset.passwordTooShort": "Password must be at least 6 characters",
    "reset.invalidToken.title": "Invalid or Expired Link",
    "reset.invalidToken.message": "This password reset link is invalid or has expired. Please request a new one.",
    "reset.requestNewLink": "Request New Link",
    "reset.success.title": "Password Reset!",
    "reset.success.message": "Your password has been successfully reset. You can now log in with your new password.",
    "reset.goToLogin": "Go to Login",
    
    // Listing Detail
    "listing.contact": "Contact Seller",
    "listing.sendMessage": "Send Message",
    "listing.messagePlaceholder": "Hi, I'm interested in this item...",
    "listing.favorite": "Add to favorites",
    "listing.share": "Share",
    "listing.save": "Save",
    "listing.report": "Report listing",
    "listing.shipping": "Shipping available",
    "listing.shippingPickupOnly": "Pickup only",
    "listing.condition": "Condition",
    "listing.location": "Location",
    "listing.posted": "Posted",
    "listing.views": "views",
    "listing.saves": "saves",
    "listing.daysAgo": "days ago",
    "listing.seller": "Seller",
    "listing.sellerInfo": "Seller Information",
    "listing.memberSince": "Member since",
    "listing.viewProfile": "View Profile",
    "listing.otherListings": "Other listings from this seller",
    "listing.similar": "Similar listings",
    "listing.description": "Description",
    "listing.details": "Details",
    "listing.category": "Category",
    "listing.subcategory": "Subcategory",
    "listing.safetyTips": "Safety tips:",
    "listing.safetyTip1": "Meet in public places",
    "listing.safetyTip2": "Check the item before paying",
    "listing.safetyTip3": "Pay only after collecting the item",
    "listing.reportListing": "Report listing",
    "listing.translating": "Translating...",
    "listing.translated": "Translated",
    "listing.translate": "Translate",
    "listing.noDescription": "No description provided.",
    "listing.locationPrivacy": "Location shown at city/town level for privacy",
    "listing.reviews": "reviews",
    "listing.verifiedSeller": "Phone-verified seller",
    "listing.soldMessage": "This item has been sold",
    "listing.soldSubtext": "Contact and save options are no longer available",
    
    // Report
    "report.title": "Report",
    "report.description": "Why are you reporting this?",
    "report.listingDescription": "Why are you reporting this listing?",
    "report.reason.spam": "Spam or misleading",
    "report.reason.inappropriate": "Inappropriate content",
    "report.reason.scam": "Scam or fraud",
    "report.reason.harassment": "Harassment or abuse",
    "report.reason.counterfeit": "Counterfeit item",
    "report.reason.other": "Other",
    "report.additionalInfo": "Additional information (optional)",
    "report.additionalPlaceholder": "Provide more details about this report...",
    "report.submit": "Submit Report",
    "report.submitting": "Submitting...",
    "report.success": "Report submitted successfully. We will review it shortly.",
    
    // Real Estate Details
    "realEstate.propertyDetails": "Property Details",
    "realEstate.livingArea": "Living Area",
    "realEstate.totalRooms": "Total Rooms",
    "realEstate.bedrooms": "Bedrooms",
    "realEstate.bathrooms": "Bathrooms",
    "realEstate.landArea": "Land Area",
    "realEstate.pricePerSqm": "Price per m²",
    "realEstate.energyDiagnostics": "Energy Diagnostics",
    "realEstate.dpe": "Energy Performance (DPE)",
    "realEstate.ges": "Greenhouse Gas Emissions (GES)",
    "realEstate.energyConsumption": "Energy consumption rating",
    "realEstate.co2Emissions": "CO₂ emissions rating",
    "realEstate.notSpecified": "Not specified",
    "realEstate.energyNote": "Energy ratings affect property value and rental eligibility. Properties rated F or G may face rental restrictions in Luxembourg and France.",
    "realEstate.buildingInfo": "Building Information",
    "realEstate.floor": "Floor",
    "realEstate.yearBuilt": "Year Built",
    "realEstate.heating": "Heating",
    "realEstate.features": "Features & Amenities",
    "realEstate.parking": "Parking",
    "realEstate.furnished": "Furnished",
    "realEstate.balcony": "Balcony",
    "realEstate.terrace": "Terrace",
    "realEstate.garden": "Garden",
    "realEstate.pool": "Pool",
    "realEstate.elevator": "Elevator",
    "realEstate.cellar": "Cellar",
    "realEstate.propertyType": "Property Type",
    
    // Common
    "common.loading": "Loading...",
    "common.sending": "Sending...",
    "common.error": "An error occurred",
    "common.retry": "Try again",
    "common.save": "Save",
    "common.cancel": "Cancel",
    "common.delete": "Delete",
    "common.edit": "Edit",
    "common.close": "Close",
    "common.yes": "Yes",
    "common.no": "No",
    "common.free": "Free",
    "common.negotiable": "Negotiable",
    "common.today": "Today",
    "common.yesterday": "Yesterday",
    "common.daysAgo": "{days} days ago",
    "common.justNow": "Just now",
    "common.hoursAgo": "{hours}h ago",
    
    // Footer
    "footer.about": "About LebonLux",
    "footer.aboutText": "LebonLux is the leading marketplace for Luxembourg and the Greater Region, connecting buyers and sellers within a 200km radius.",
    "footer.quickLinks": "Quick Links",
    "footer.support": "Support",
    "footer.legal": "Legal",
    "footer.contact": "Contact Us",
    "footer.help": "Help Center",
    "footer.safety": "Safety Tips",
    "footer.terms": "Terms of Service",
    "footer.privacy": "Privacy Policy",
    "footer.cookies": "Cookie Policy",
    "footer.copyright": "© {year} LebonLux. All rights reserved.",
    // Not Found
    "notFound.title": "Page not found",
    "notFound.description": "The page you're looking for doesn't exist or has been moved.",
    "notFound.goHome": "Back to home",
    "notFound.browseListings": "Browse listings",
    "notFound.goBack": "Go back",
    "listing.noReviewsYet": "No reviews yet",
    "search.seeAllFor": "See all results for",
    "search.noSuggestions": "No matches yet. Try the full search:"
  },
  
  fr: {
    "messages.viewProfile": "Voir le profil",
    "header.savedSearches": "Recherches sauvegardées",
    "saved.kicker": "Vos alertes",
    "saved.title": "Recherches sauvegardées",
    "saved.subtitle": "Nous surveillons le marché pour vous : les nouvelles annonces correspondantes apparaissent ici et dans votre boîte mail.",
    "saved.count": "{n} sauvegardées",
    "saved.totalNew": "{n} nouvelles annonces depuis votre dernière visite",
    "saved.new": "{n} nouvelles",
    "saved.noNew": "Rien de nouveau",
    "saved.freq.instant": "Instantané",
    "saved.freq.daily": "Résumé quotidien",
    "saved.freq.off": "Désactivé",
    "saved.freq.instantHint": "E-mail dès qu’une nouvelle annonce correspond (max. un par heure)",
    "saved.freq.dailyHint": "Un e-mail récapitulatif chaque matin à 8h00",
    "saved.freq.offHint": "Aucun e-mail, seulement le badge sur cette page",
    "saved.view": "Voir les résultats",
    "saved.rename": "Renommer",
    "saved.delete": "Supprimer",
    "saved.deleteTitle": "Supprimer cette recherche sauvegardée ?",
    "saved.deleteText": "Vous ne recevrez plus d’alertes pour « {name} ».",
    "saved.cancel": "Annuler",
    "saved.empty": "Aucune recherche sauvegardée",
    "saved.emptyText": "Lancez une recherche, appuyez sur « Sauvegarder la recherche » et nous vous préviendrons des nouveautés.",
    "saved.startSearching": "Commencer à chercher",
    "saved.newSearch": "Nouvelle recherche",
    "saved.updated": "Recherche mise à jour",
    "saved.deleted": "Recherche supprimée",
    "saved.failed": "Une erreur est survenue, veuillez réessayer",
    "saved.allListings": "Toutes les annonces",
    "saved.upTo": "Jusqu’à {n} €",
    "saved.from": "À partir de {n} €",
    "saved.manage": "Gérer mes recherches",
    "saved.signIn": "Connectez-vous pour voir vos recherches sauvegardées",
    "home.latest.forYou": "Recommandées pour vous",
    "feed.notInterested": "Pas intéressé",
    "feed.hidden": "Nous vous montrerons moins d'annonces comme celle-ci.",
    "feed.undo": "Annuler",
    "feed.why.similar_to_favourites": "Similaire à vos favoris",
    "feed.why.viewed_subcategory": "Parce que vous avez consulté des articles similaires",
    "feed.why.favourite_category": "Dans une catégorie que vous suivez",
    "feed.why.near_you": "Près de chez vous",
    "feed.why.new_and_popular": "Nouveau et populaire",
    "feed.why.explore": "Pour changer",
    "profile.personalization": "Recommandations personnalisées",
    "profile.personalizationHint": "Utiliser mes consultations, favoris, recherches et messages pour classer la page d'accueil. Désactivé = le même fil que tout le monde.",
    "profile.clearHistory": "Effacer mon historique de recommandations",
    "phoneVerify.badgeHint": "Ce membre a confirmé par code SMS qu'il contrôle un numéro de mobile. Ce n'est pas une vérification d'identité et cela ne garantit pas la transaction.",
    "phoneVerify.title": "Vérifiez votre numéro de téléphone",
    "phoneVerify.subtitle": "Pour la sécurité de tous, chaque membre confirme une fois son numéro de mobile avant d'envoyer des messages. Nous envoyons uniquement un code par SMS — votre numéro reste privé.",
    "phoneVerify.phoneLabel": "Numéro de mobile",
    "phoneVerify.sendCode": "Envoyer le code",
    "phoneVerify.sending": "Envoi…",
    "phoneVerify.codeSentTo": "Nous avons envoyé un code à 6 chiffres au",
    "phoneVerify.codeLabel": "Saisissez le code",
    "phoneVerify.verify": "Vérifier",
    "phoneVerify.verifying": "Vérification…",
    "phoneVerify.resend": "Renvoyer le code",
    "phoneVerify.resendIn": "Renvoyer dans {s}s",
    "phoneVerify.changeNumber": "Changer de numéro",
    "phoneVerify.successTitle": "Téléphone vérifié",
    "phoneVerify.successText": "Merci ! Vous pouvez maintenant échanger avec les acheteurs et vendeurs.",
    "phoneVerify.continue": "Continuer",
    "phoneVerify.required": "Veuillez vérifier votre numéro de téléphone pour envoyer des messages.",
    "phoneVerify.mockHint": "Mode test : utilisez le code 123456",
    "phoneVerify.verifyButton": "Vérifier mon téléphone",
    "phoneVerify.verifiedLabel": "Téléphone vérifié",
    "phoneVerify.notVerifiedLabel": "Téléphone non vérifié",
    "phoneVerify.err.invalid_phone": "Ce numéro de téléphone n'est pas valide.",
    "phoneVerify.err.country_not_allowed": "Seuls les numéros du Luxembourg, de France, Belgique, Allemagne, Portugal, Italie et Espagne sont acceptés.",
    "phoneVerify.err.mobile_required": "Veuillez utiliser un numéro de mobile.",
    "phoneVerify.err.phone_already_used": "Ce numéro est déjà vérifié sur un autre compte.",
    "phoneVerify.err.incorrect_code": "Code incorrect. {n} essais restants.",
    "phoneVerify.err.expired": "Ce code a expiré. Demandez un nouveau code.",
    "phoneVerify.err.attempts_exhausted": "Trop de tentatives. Demandez un nouveau code.",
    "phoneVerify.err.resend_cooldown": "Veuillez patienter avant de demander un nouveau code.",
    "phoneVerify.err.provider_error": "Impossible d'envoyer le SMS pour le moment. Réessayez dans un instant.",
    "phoneVerify.err.generic": "Une erreur est survenue. Veuillez réessayer.",
    "profile.standard": "Standard",
    "category.byCity": "Parcourir par ville",
    "home.latest.discover": "Recommandées",
    "filters.moreCriteria": "Plus de critères ({count})",
    "filters.lessCriteria": "Moins de critères",
    "auth.register.err.emailExists": "Cet email est déjà utilisé. Essayez de vous connecter.",
    "edit.title": "Modifier l'annonce",
    "edit.basicDetails": "Informations principales",
    "edit.saving": "Enregistrement...",
    "edit.success": "Annonce mise à jour !",
    "edit.err.load": "Impossible de charger l'annonce",
    "edit.err.update": "Impossible de mettre à jour l'annonce. Veuillez réessayer.",
    "auth.register.subtitle": "Créez un compte pour acheter et vendre.",
    "auth.register.passwordPlaceholder": "Créez un mot de passe",
    "auth.register.req.length": "Au moins 8 caractères",
    "auth.register.req.upper": "Une majuscule",
    "auth.register.req.number": "Un chiffre",
    "auth.register.err.terms": "Veuillez accepter les conditions d'utilisation",
    "auth.register.err.password": "Le mot de passe ne respecte pas toutes les exigences",
    "auth.register.err.failed": "Inscription impossible. Veuillez réessayer.",
    "auth.register.err.google": "L'inscription avec Google a échoué",
    "auth.register.agree": "J'accepte les",
    "auth.register.termsLink": "Conditions d'utilisation",
    "auth.register.and": "et la",
    "auth.register.privacyLink": "Politique de confidentialité",
    "auth.register.creating": "Création du compte...",
    "auth.login.err.invalid": "Email ou mot de passe incorrect",
    "auth.login.err.google": "La connexion avec Google a échoué",
    "listing.ownerActions": "Gérer votre annonce",
    "myListings.actions.markSold": "Marquer vendu",
    "myListings.actions.reactivate": "Réactiver",
    "myListings.views": "vues",
    "myListings.sold.title": "Marquer comme vendu ?",
    "myListings.sold.text": "« {title} » sera affichée comme vendue. Les conversations sans offre acceptée seront fermées. Vous pourrez la réactiver plus tard.",
    "myListings.toast.sold": "Annonce marquée comme vendue",
    "myListings.toast.deleted": "Annonce supprimée",
    "myListings.toast.reactivated": "Annonce réactivée",
    "myListings.toast.failed": "L'action a échoué, veuillez réessayer",
    // Header
    "header.categories": "Catégories",
    "header.searchPlaceholder": "Rechercher des articles...",
    "header.login": "Connexion",
    "header.signup": "S'inscrire",
    "header.sell": "Vendre",
    "header.favorites": "Favoris",
    "header.messages": "Messages",
    "header.myListings": "Mes annonces",
    "header.profile": "Profil",
    
    // Navigation
    "nav.categories": "Catégories",
    "nav.sell": "Vendre un article",
    "nav.logout": "Se déconnecter",
    "nav.myProfile": "Mon profil",
    "nav.myListings": "Mes annonces",
    "nav.favorites": "Favoris",
    "nav.messages": "Messages",
    "nav.login": "Connexion",
    "nav.signup": "S'inscrire",
    "cond.new-with-tags": "Neuf avec étiquette",
    "cond.excellent": "Excellent état",
    "cond.very-good": "Très bon état",
    "cond.used": "Usagé",
    "filters.details": "Caractéristiques",
    "filters.min": "Min",
    "filters.max": "Max",
    "filters.priceRange": "Prix",
    "filters.anyCondition": "Tous états",
    "profile.tabSaved": "Annonces sauvegardées",
    "profile.tabSearches": "Recherches sauvegardées",
    "profile.tabSettings": "Paramètres",
    "messages.sendFailed": "Votre message n'a pas pu être envoyé. Veuillez réessayer.",
    "messages.signIn": "Connectez-vous pour voir vos messages",
    "messages.noConversations": "Aucune conversation pour le moment",
    "messages.startConversation": "Contactez un vendeur pour démarrer une conversation",
    "messages.selectConversation": "Sélectionnez une conversation",
    "messages.chooseConversation": "Choisissez une conversation existante ou démarrez-en une nouvelle",
    "messages.attachFile": "Joindre un fichier",
    "messages.attachImage": "Joindre une image",
    "messages.searchPlaceholder": "Rechercher des conversations…",
    "messages.markAllRead": "Tout marquer comme lu",
    "report.title": "Signaler",
    "report.description": "Pourquoi signalez-vous ceci ?",
    "report.listingDescription": "Pourquoi signalez-vous cette annonce ?",
    "report.reason.spam": "Spam ou trompeur",
    "report.reason.inappropriate": "Contenu inapproprié",
    "report.reason.scam": "Arnaque ou fraude",
    "report.reason.harassment": "Harcèlement ou abus",
    "report.reason.counterfeit": "Contrefaçon",
    "report.reason.other": "Autre",
    "report.additionalInfo": "Informations complémentaires (facultatif)",
    "report.additionalPlaceholder": "Donnez plus de détails sur ce signalement…",
    "report.submit": "Envoyer le signalement",
    "report.submitting": "Envoi…",
    "report.success": "Signalement envoyé. Nous l'examinerons rapidement.",
    "filters.category": "Catégorie",
    "filters.allCategories": "Toutes les catégories",
    "filters.subcategory": "Sous-catégorie",
    "filters.allSubcategories": "Toutes les sous-catégories",
    "filters.condition": "État",
    "filters.location": "Localisation",
    "filters.yourLocation": "Votre position",
    "filters.transaction": "Type de transaction",
    "filters.saleOrRent": "Vente ou location",
    "filters.any": "Indifférent",
    "filters.forSale": "À vendre",
    "filters.forRent": "À louer",
    "filters.realEstate": "Filtres immobilier",
    "filters.vehicles": "Filtres véhicules",
    "filters.surface": "Surface (m²)",
    "filters.minRooms": "Pièces min.",
    "filters.brand": "Marque",
    "filters.anyBrand": "Toutes les marques",
    "filters.year": "Année (à partir de)",
    "filters.anyYear": "Toutes les années",
    "filters.mileage": "Kilométrage max.",
    "filters.anyMileage": "Tous kilométrages",
    "filters.fuel": "Carburant",
    "filters.anyFuel": "Tous carburants",
    "filters.search": "Rechercher",
    "filters.saveSearch": "Sauvegarder la recherche",
    "filters.saveFailed": "Impossible de sauvegarder la recherche. Réessayez.",
    "filters.list": "Liste",
    "filters.map": "Carte",
    "filters.searchName": "Nom de la recherche",
    "filters.searchNamePlaceholder": "ex. Appartements à moins de 1 500 €",
    "filters.emailAlerts": "Alertes e-mail",
    "filters.emailAlertsHint": "Soyez averti dès qu'une nouvelle annonce correspond",
    "cond.new": "Neuf",
    "cond.like-new": "Comme neuf",
    "cond.good": "Bon état",
    "cond.fair": "État correct",
    "cond.poor": "Usé",
    "category.notFound": "Catégorie introuvable",
    "category.notFoundText": "Cette catégorie n'existe pas.",
    "category.backHome": "Retour à l'accueil",
    "category.empty": "Aucune annonce dans cette catégorie",
    "myListings.signIn": "Connectez-vous pour voir vos annonces",
    "myListings.signInText": "Gérez toutes vos annonces au même endroit",
    "myListings.shipping": "Livraison",
    "auth.signIn": "Se connecter",
    "footer.serving": "Présent en :",
    "footer.howItWorks": "Comment ça marche",
    "footer.faq": "FAQ",
    "footer.aboutUs": "À propos",
    "footer.careers": "Carrières",
    "country.luxembourg": "Luxembourg",
    "country.germany": "Allemagne",
    "country.france": "France",
    "country.belgium": "Belgique",
    "profile.logout": "Se déconnecter",
    "profile.noSaved": "Aucune annonce sauvegardée",
    "profile.noSavedText": "Sauvegardez des annonces en touchant le cœur",
    "profile.noSearches": "Aucune recherche sauvegardée",
    "profile.notifications": "Paramètres de notification",
    "profile.notificationsText": "Choisissez comment vous êtes averti",
    "profile.emailNotifications": "Notifications par e-mail",
    "profile.accountInfo": "Informations du compte",
    "profile.accountInfoText": "Les détails de votre compte",
    "profile.email": "E-mail",
    "profile.accountStatus": "Statut du compte",
    "explore.savedSearches": "Vos recherches sauvegardées",
    "search.trending": "Recherches populaires",
    "search.recentlyViewed": "Vus récemment",
    "search.clearRecent": "Effacer",
    "messages.repliesIn": "Répond en {time}",
    "messages.replyRateShort": "{rate} % de réponses",
    "messages.memberSince": "Membre depuis {date}",
    "nav.allCategories": "Toutes les catégories",
    "nav.admin": "Admin",
    "browser.viewAll": "Tout voir dans {name}",
    "browser.ads": "annonces",
    "browser.ad": "annonce",
    "header.logout": "Déconnexion",
    "header.tagline": "Luxembourg et environs | Achetez et vendez localement dans un rayon de 200km",
    
    // Homepage
    "home.hero.title": "Achetez & Vendez au",
    "home.hero.highlight": "Luxembourg et environs",
    "home.hero.subtitle": "Achetez et vendez localement au Luxembourg et dans les villes voisines. Annonces gratuites, navigation en 4 langues, remise en main propre.",
    "home.search.placeholder": "Que recherchez-vous ?",
    "home.search.allLocations": "Toutes les localités",
    "home.search.button": "Rechercher",
    "home.search.minPrice": "Min €",
    "home.search.maxPrice": "Max €",
    "home.search.filters": "Filtres",
    "home.search.advanced": "Recherche avancée",
    "home.search.clearFilters": "Effacer les filtres",
    "home.search.applyFilters": "Appliquer",
    "home.search.clearAll": "Tout effacer",
    "home.search.filterBy": "Filtrer par",
    "home.search.selectOption": "Sélectionner",
    "home.search.all": "Tous",
    "home.search.results": "résultats",
    "home.search.resultsIn": "à",
    "home.popular": "Populaire :",
    
    // Map Search
    "mapSearch.title": "Recherche Immobilière",
    "mapSearch.propertiesFound": "biens trouvés",
    "mapSearch.onMap": "sur la carte",
    "mapSearch.map": "Carte",
    "mapSearch.list": "Liste",
    "mapSearch.filters": "Filtres",
    "mapSearch.listingType": "Type d'annonce",
    "mapSearch.propertyType": "Type de bien",
    "mapSearch.price": "Prix",
    "mapSearch.minRooms": "Pièces minimum",
    "mapSearch.all": "Tous",
    "mapSearch.forSale": "À vendre",
    "mapSearch.forRent": "À louer",
    "mapSearch.anyRooms": "Peu importe",
    "mapSearch.resetFilters": "Réinitialiser",
    "mapSearch.viewListing": "Voir l'annonce",
    "mapSearch.noProperties": "Aucun bien trouvé",
    "common.loading": "Chargement...",
    
    "home.cta.title": "C'est le moment de vendre !",
    "home.cta.subtitle": "Déposez votre annonce gratuitement et atteignez des milliers d'acheteurs",
    "home.cta.button": "Déposer une annonce",
    "home.noResults.title": "Aucune annonce trouvée",
    "home.noResults.subtitle": "Aucune annonce ne correspond à vos critères",
    "home.noResults.beFirst": "Soyez le premier à publier une annonce !",
    "home.stats.listings": "Annonces actives",
    "home.stats.users": "Membres inscrits",
    "home.stats.countries": "Pays",
    "home.mapSearch": "Recherche carte",
    "home.viewOnMap": "Voir sur la carte",
    "home.map": "Carte",
    "home.categories.title": "Parcourir par catégorie",
    "home.categories.viewAll": "Voir tout",
    "home.featured.title": "Annonces en vedette",
    "home.featured.seeAll": "Voir tout",
    "home.latest.title": "Annonces recommandées",
    "home.latest.category": "Catégorie",
    "home.latest.newest": "Plus récent",
    "home.latest.priceLow": "Prix : croissant",
    "home.latest.priceHigh": "Prix : décroissant",
    "home.latest.popular": "Plus populaire",
    "home.latest.loadMore": "Charger plus d'annonces",
    "home.latest.noListings": "Aucune annonce trouvée",
    "home.latest.createFirst": "Créer la première annonce",
    "home.why.title": "Pourquoi choisir LebonLux ?",
    "home.why.verified.title": "Vendeurs vérifiés",
    "home.why.verified.desc": "Achetez en toute confiance auprès de vendeurs vérifiés avec des évaluations.",
    "home.why.local.title": "Local et transfrontalier",
    "home.why.local.desc": "Trouvez des offres au Luxembourg et dans les régions voisines dans 4 pays.",
    "home.why.ai.title": "Annonces assistées par IA",
    "home.why.ai.desc": "Vendez plus rapidement grâce à la catégorisation automatique et aux suggestions de prix.",
    
    // Categories - Unified with Leboncoin
    "category.vehicules": "Véhicules",
    "category.immobilier": "Immobilier",
    "category.vacances": "Locations de vacances",
    "category.emploi": "Emploi",
    "category.mode": "Mode",
    "category.maison-jardin": "Maison & Jardin",
    "category.famille": "Famille",
    "category.electronique": "Électronique",
    "category.loisirs": "Loisirs",
    "category.services": "Services",
    "category.materiel-pro": "Matériel professionnel",
    "category.art": "Art",
    "category.autres": "Autres",
    "category.ads": "annonces",
    "category.listingsFound": "{count} annonces trouvées",
    "category.noListingsFound": "Aucune annonce dans cette catégorie",
    "category.loadMore": "Voir plus d'annonces",
    "category.all": "Toutes",
    "category.allConditions": "Tous les états",
    "category.condition": "État",
    "category.filters": "Filtres",
    "category.clearAll": "Tout effacer",
    "category.clearAllFilters": "Effacer tous les filtres",
    "category.clearFilters": "Effacer les filtres",
    "sort.newest": "Plus récentes",
    "sort.priceLow": "Prix : croissant",
    "sort.priceHigh": "Prix : décroissant",
    "sort.popular": "Plus populaires",
    "sort.oldest": "Plus anciennes",
    "sort.label": "Trier par",
    "followup.label": "Petit rappel",
    "followup.yes": "Oui, toujours intéressé(e)",
    "followup.no": "Non merci",
    "followup.answeredYes": "Vous avez répondu : toujours intéressé(e) 👍",
    "followup.answeredNo": "Vous avez répondu : plus intéressé(e)",
    "followup.sellerHint": "Nous avons demandé à l'acheteur s'il est toujours intéressé.",
    "sold.prompt.title": "Offre acceptée !",
    "sold.prompt.description": "Marquer « {title} » comme vendu ? Les autres acheteurs seront informés et cette conversation reste ouverte pour organiser la remise.",
    "sold.prompt.hint": "L'annonce reste visible 30 jours avec le badge « Vendu ».",
    "sold.prompt.confirm": "Marquer comme vendu",
    "sold.prompt.later": "Plus tard",
    "sold.prompt.done": "Annonce marquée comme vendue 🎉",
    "sold.banner.text": "Vous avez accepté une offre pour « {title} ».",
    "sold.banner.cta": "Marquer comme vendu",
    "listing.sold": "Vendu",
    "messages.closedSold": "Conversation fermée — l'annonce a été vendue",
    "safety.nudge": "Restez prudent : rencontrez-vous dans un lieu public, payez seulement l'article en main, jamais d'acompte ni de paiement hors LebonLux.",
    
    // Create Listing
    "create.title": "Créer une annonce",
    "create.step.photos": "Photos",
    "create.step.details": "Détails",
    "create.step.price": "Prix & Localisation",
    "create.photos.title": "Ajouter des photos",
    "create.photos.subtitle": "Ajoutez jusqu'à 10 photos. La première sera la photo de couverture.",
    "create.photos.upload": "Cliquez pour télécharger des photos",
    "create.photos.dragDrop": "ou glissez-déposez",
    "create.photos.cover": "Couverture",
    "create.photos.optional": "Les photos sont optionnelles - vous pouvez les ajouter plus tard",
    "create.photos.skipAI": "Passer et catégoriser manuellement",
    "create.ai.title": "Remplissage automatique par IA",
    "create.ai.subtitle": "Laissez notre IA analyser vos photos pour suggérer automatiquement la catégorie, le titre, la description et le prix.",
    "create.ai.analyze": "Analyser les photos",
    "create.ai.analyzing": "Analyse en cours...",
    "create.ai.category": "Catégorie suggérée",
    "create.ai.titleSuggestion": "Titre suggéré",
    "create.ai.retailValue": "Valeur estimée neuf",
    "create.ai.suggestedPrice": "Prix de vente suggéré",
    "create.ai.confidence": "Confiance",
    "create.ai.apply": "Appliquer les suggestions",
    "create.ai.suggestPrice": "Prix IA",
    "create.ai.calculating": "Calcul...",
    "create.ai.suggestedRange": "Fourchette IA suggérée",
    "create.ai.priceError": "Veuillez d'abord remplir le titre, la catégorie et l'état",
    "create.ai.priceSuggestionFailed": "Impossible d'obtenir une suggestion de prix IA. Veuillez entrer le prix manuellement.",
    "create.details.title": "Détails de l'article",
    "create.details.subtitle": "Décrivez votre article aux acheteurs.",
    "create.details.itemTitle": "Titre",
    "create.details.titlePlaceholder": "ex: iPhone 14 Pro - Excellent état",
    "create.details.description": "Description",
    "create.details.descPlaceholder": "Décrivez votre article - état, caractéristiques, raison de la vente...",
    "create.details.category": "Catégorie",
    "create.details.selectCategory": "Sélectionner une catégorie",
    "create.details.subcategory": "Sous-catégorie",
    "create.details.selectSubcategory": "Sélectionner une sous-catégorie",
    "create.details.condition": "État",
    "create.details.selectCondition": "Sélectionner l'état",
    "create.details.attributes": "Détails supplémentaires",
    "create.price.title": "Prix & Localisation",
    "create.price.subtitle": "Définissez votre prix et confirmez votre localisation.",
    "create.price.type": "Type de prix",
    "create.price.fixed": "Fixe",
    "create.price.negotiable": "Négociable",
    "create.price.free": "Gratuit",
    "create.price.amount": "Prix (€)",
    "create.price.retailHint": "Valeur neuf : {value} €",
    "create.location.title": "Localisation",
    "create.location.select": "Sélectionnez votre localisation",
    "create.location.change": "Modifier",
    "create.shipping.title": "Livraison disponible",
    "create.shipping.subtitle": "Proposer l'expédition aux acheteurs",
    "create.preview": "Aperçu",
    "create.preview.title": "Titre de votre annonce",
    "create.preview.selectLocation": "Sélectionner la localisation",
    "create.nav.back": "Retour",
    "create.nav.continue": "Continuer",
    "create.nav.publish": "Publier l'annonce",
    "create.nav.publishing": "Publication...",
    "create.location.popup.title": "Où êtes-vous situé ?",
    "create.location.popup.detect": "Utiliser ma position actuelle",
    "create.location.popup.detecting": "Détection de la position...",
    "create.location.popup.manual": "Ou entrez manuellement",
    "create.location.popup.search": "Rechercher une ville...",
    "create.location.popup.hint": "Nous desservons le Luxembourg et les régions environnantes dans un rayon de 200km",
    
    // My Listings
    "myListings.title": "Mes annonces",
    "myListings.count": "{count} annonces actives",
    "myListings.newListing": "Nouvelle annonce",
    "myListings.empty.title": "Pas encore d'annonces",
    "myListings.empty.subtitle": "Commencez à vendre en créant votre première annonce",
    "myListings.empty.button": "Créer votre première annonce",
    "myListings.actions.view": "Voir",
    "myListings.actions.edit": "Modifier",
    "myListings.actions.delete": "Supprimer",
    "myListings.delete.title": "Supprimer l'annonce",
    "myListings.delete.whyDelete": "Pourquoi supprimez-vous cette annonce ?",
    "myListings.delete.confirm": "Êtes-vous sûr de vouloir supprimer « {title} » ? Cette action est irréversible.",
    "myListings.delete.cancel": "Annuler",
    "myListings.delete.deleting": "Suppression...",
    "myListings.delete.markingSold": "Marquage comme vendu...",
    "myListings.delete.markSold": "Marquer comme vendu",
    "myListings.delete.otherPlaceholder": "Veuillez préciser la raison...",
    "myListings.delete.congrats": "Félicitations pour votre vente ! Votre annonce sera marquée comme VENDUE et restera visible pour les autres. Toutes les conversations seront clôturées.",
    "myListings.deleteReason.soldHere": "Vendu sur LebonLux",
    "myListings.deleteReason.soldElsewhere": "Vendu ailleurs",
    "myListings.deleteReason.noLongerSelling": "Je ne veux plus vendre",
    "myListings.deleteReason.other": "Autre raison",
    
    // Favorites
    "favorites.title": "Mes favoris",
    "favorites.savedItems": "articles enregistrés",
    "favorites.signIn": "Connectez-vous pour voir vos favoris",
    "favorites.signInSubtitle": "Enregistrez les articles que vous aimez et revenez-y à tout moment",
    "favorites.empty": "Pas encore de favoris",
    "favorites.emptySubtitle": "Commencez à enregistrer les articles en cliquant sur l'icône cœur",
    "favorites.browse": "Parcourir les annonces",
    
    // Messages
    "messages.title": "Messages",
    "messages.search": "Rechercher des conversations...",
    "messages.empty": "Pas encore de conversations",
    "messages.emptyHint": "Démarrez une conversation en contactant un vendeur",
    "messages.select": "Sélectionnez une conversation",
    "messages.selectHint": "Choisissez parmi vos conversations existantes ou démarrez-en une nouvelle",
    "messages.responseTime": "Répond généralement dans l'heure",
    "messages.report": "Signaler",
    "messages.deleteConversation": "Supprimer la conversation",
    "messages.inputPlaceholder": "Tapez un message...",
    
    // Auth
    "auth.login.title": "Bon retour ! Connectez-vous pour continuer.",
    "auth.login.google": "Continuer avec Google",
    "auth.login.or": "ou",
    "auth.login.email": "Email",
    "auth.login.emailPlaceholder": "votre@email.com",
    "auth.login.password": "Mot de passe",
    "auth.login.forgot": "Mot de passe oublié ?",
    "auth.login.button": "Se connecter",
    "auth.login.noAccount": "Pas encore de compte ?",
    "auth.login.signup": "S'inscrire",
    "auth.register.title": "Créez votre compte",
    "auth.register.name": "Nom complet",
    "auth.register.namePlaceholder": "Jean Dupont",
    "auth.register.button": "Créer un compte",
    "auth.register.hasAccount": "Déjà un compte ?",
    "auth.register.login": "Se connecter",
    "auth.register.terms": "En vous inscrivant, vous acceptez nos Conditions et notre Politique de confidentialité",
    "auth.email": "Email",
    "auth.emailPlaceholder": "votre@email.com",
    
    // Forgot Password
    "forgot.title": "Mot de passe oublié ?",
    "forgot.subtitle": "Entrez votre email et nous vous enverrons un lien pour réinitialiser votre mot de passe.",
    "forgot.sendLink": "Envoyer le lien",
    "forgot.sending": "Envoi en cours...",
    "forgot.backToLogin": "Retour à la connexion",
    "forgot.success.title": "Vérifiez vos emails",
    "forgot.success.message": "Si un compte existe avec cet email, nous vous avons envoyé un lien de réinitialisation.",
    "forgot.success.checkSpam": "Vous ne le voyez pas ? Vérifiez votre dossier spam.",
    
    // Reset Password
    "reset.title": "Réinitialiser le mot de passe",
    "reset.subtitle": "Entrez votre nouveau mot de passe pour",
    "reset.newPassword": "Nouveau mot de passe",
    "reset.newPasswordPlaceholder": "Entrez le nouveau mot de passe",
    "reset.confirmPassword": "Confirmer le mot de passe",
    "reset.confirmPasswordPlaceholder": "Confirmez le nouveau mot de passe",
    "reset.resetButton": "Réinitialiser",
    "reset.resetting": "Réinitialisation...",
    "reset.verifying": "Vérification du lien...",
    "reset.passwordMismatch": "Les mots de passe ne correspondent pas",
    "reset.passwordTooShort": "Le mot de passe doit contenir au moins 6 caractères",
    "reset.invalidToken.title": "Lien invalide ou expiré",
    "reset.invalidToken.message": "Ce lien de réinitialisation est invalide ou a expiré. Veuillez en demander un nouveau.",
    "reset.requestNewLink": "Demander un nouveau lien",
    "reset.success.title": "Mot de passe réinitialisé !",
    "reset.success.message": "Votre mot de passe a été réinitialisé avec succès. Vous pouvez maintenant vous connecter.",
    "reset.goToLogin": "Aller à la connexion",
    
    // Listing Detail
    "listing.contact": "Contacter le vendeur",
    "listing.sendMessage": "Envoyer un message",
    "listing.messagePlaceholder": "Bonjour, je suis intéressé par cet article...",
    "listing.favorite": "Ajouter aux favoris",
    "listing.share": "Partager",
    "listing.save": "Sauvegarder",
    "listing.report": "Signaler l'annonce",
    "listing.shipping": "Livraison disponible",
    "listing.shippingPickupOnly": "Retrait uniquement",
    "listing.condition": "État",
    "listing.location": "Localisation",
    "listing.posted": "Publié",
    "listing.views": "vues",
    "listing.saves": "sauvegardes",
    "listing.daysAgo": "jours",
    "listing.seller": "Vendeur",
    "listing.sellerInfo": "Informations sur le vendeur",
    "listing.memberSince": "Membre depuis",
    "listing.viewProfile": "Voir le profil",
    "listing.otherListings": "Autres annonces de ce vendeur",
    "listing.similar": "Annonces similaires",
    "listing.description": "Description",
    "listing.details": "Détails",
    "listing.category": "Catégorie",
    "listing.subcategory": "Sous-catégorie",
    "listing.safetyTips": "Conseils de sécurité :",
    "listing.safetyTip1": "Rencontrez-vous dans des lieux publics",
    "listing.safetyTip2": "Vérifiez l'article avant de payer",
    "listing.safetyTip3": "Payez uniquement après avoir récupéré l'article",
    "listing.reportListing": "Signaler l'annonce",
    "listing.translating": "Traduction...",
    "listing.translated": "Traduit",
    "listing.translate": "Traduire",
    "listing.noDescription": "Aucune description fournie.",
    "listing.locationPrivacy": "Localisation affichée au niveau ville pour la confidentialité",
    "listing.reviews": "avis",
    "listing.verifiedSeller": "Vendeur au téléphone vérifié",
    "listing.soldMessage": "Cet article a été vendu",
    "listing.soldSubtext": "Les options de contact et de sauvegarde ne sont plus disponibles",
    
    // Real Estate Details
    "realEstate.propertyDetails": "Détails du bien",
    "realEstate.livingArea": "Surface habitable",
    "realEstate.totalRooms": "Nombre de pièces",
    "realEstate.bedrooms": "Chambres",
    "realEstate.bathrooms": "Salles de bain",
    "realEstate.landArea": "Superficie du terrain",
    "realEstate.pricePerSqm": "Prix au m²",
    "realEstate.energyDiagnostics": "Diagnostics énergétiques",
    "realEstate.dpe": "Performance énergétique (DPE)",
    "realEstate.ges": "Émissions de gaz à effet de serre (GES)",
    "realEstate.energyConsumption": "Classe de consommation énergétique",
    "realEstate.co2Emissions": "Classe d'émissions CO₂",
    "realEstate.notSpecified": "Non spécifié",
    "realEstate.energyNote": "Les classes énergétiques affectent la valeur du bien et l'éligibilité à la location. Les biens classés F ou G peuvent faire l'objet de restrictions de location au Luxembourg et en France.",
    "realEstate.buildingInfo": "Informations sur le bâtiment",
    "realEstate.floor": "Étage",
    "realEstate.yearBuilt": "Année de construction",
    "realEstate.heating": "Chauffage",
    "realEstate.features": "Caractéristiques et équipements",
    "realEstate.parking": "Parking",
    "realEstate.furnished": "Meublé",
    "realEstate.balcony": "Balcon",
    "realEstate.terrace": "Terrasse",
    "realEstate.garden": "Jardin",
    "realEstate.pool": "Piscine",
    "realEstate.elevator": "Ascenseur",
    "realEstate.cellar": "Cave",
    "realEstate.propertyType": "Type de bien",
    
    // Common
    "common.loading": "Chargement...",
    "common.sending": "Envoi...",
    "common.error": "Une erreur s'est produite",
    "common.retry": "Réessayer",
    "common.save": "Enregistrer",
    "common.cancel": "Annuler",
    "common.delete": "Supprimer",
    "common.edit": "Modifier",
    "common.close": "Fermer",
    "common.yes": "Oui",
    "common.no": "Non",
    "common.free": "Gratuit",
    "common.negotiable": "Négociable",
    "common.today": "Aujourd'hui",
    "common.yesterday": "Hier",
    "common.daysAgo": "il y a {days} jours",
    "common.justNow": "À l'instant",
    "common.hoursAgo": "il y a {hours}h",
    "common.saving": "Enregistrement...",
    "common.saveChanges": "Enregistrer les modifications",
    
    // Profile
    "profile.signInRequired": "Connectez-vous pour voir votre profil",
    "profile.editProfile": "Modifier le profil",
    "profile.verified": "Téléphone vérifié",
    "profile.basicInfo": "Informations de base",
    "profile.name": "Nom",
    "profile.phone": "Numéro de téléphone",
    "search.noResultsFor": "Aucun résultat pour « {q} »",
    "search.noListings": "Aucune annonce",
    "search.tryDifferent": "Essayez d’autres mots-clés ou filtres",
    "search.clearFilters": "Effacer les filtres",
    "search.searching": "Recherche…",
    "search.items": "{n} annonces",
    "badge.new": "Nouveau",
    "badge.priceDrop": "Prix baissé",
    "badge.shipping": "Livraison possible",
    "badge.saves": "{n} sauvegardes",
    "badge.savesLong": "{n} personnes ont sauvegardé cette annonce",
    "alerts.title": "Peu de résultats ? Soyez prévenu",
    "alerts.text": "Nous vous envoyons un e-mail dès qu’une nouvelle annonce correspond à cette recherche.",
    "alerts.cta": "Créer une alerte",
    "alerts.created": "Alerte créée — nous vous préviendrons des nouvelles annonces",
    "alerts.exists": "Vous avez déjà une alerte pour cette recherche",
    "alerts.manage": "Gérer mes alertes",
    "alerts.login": "Connectez-vous pour créer l’alerte — votre recherche est conservée",
    "profile.replyRate": "Taux de réponse",
    "profile.replyTime": "Répond en",
    "profile.stats.sold": "Vendus",
    "buyer.contact": "Contacter le vendeur",
    "buyer.contactPrice": "Contacter le vendeur • {price}",
    "buyer.send": "Envoyer le message",
    "buyer.dialogTitle": "Écrire au vendeur",
    "buyer.messagePlaceholder": "Bonjour, cet article est-il toujours disponible ?",
    "buyer.quick.available": "Toujours disponible ?",
    "buyer.quick.lastPrice": "Dernier prix ?",
    "buyer.quick.visit": "Possible de venir voir ?",
    "buyer.quick.delivery": "Livraison possible ?",
    "buyer.offer.cta": "Faire une offre",
    "buyer.offer.title": "Votre offre",
    "buyer.offer.hint": "Le vendeur pourra accepter ou refuser dans la discussion.",
    "buyer.offer.send": "Envoyer l’offre de {amount} €",
    "buyer.offer.accept": "Accepter",
    "buyer.offer.decline": "Refuser",
    "buyer.offer.pending": "Offre en attente",
    "buyer.offer.accepted": "Offre acceptée",
    "buyer.offer.declined": "Offre refusée",
    "buyer.offer.yours": "Votre offre",
    "buyer.sentToast": "Message envoyé — le vendeur a été prévenu",
    "buyer.savedDraft": "Connectez-vous pour envoyer votre message — nous l’avons gardé",
    "buyer.seller.replyRate": "Taux de réponse",
    "buyer.seller.replyTime": "Répond en",
    "buyer.seller.listings": "Annonces",
    "buyer.seller.memberSince": "Membre depuis {date}",
    "buyer.seller.call": "Appeler le vendeur",
    "buyer.seller.replyMinutes": "~{n} min",
    "buyer.seller.replyHours": "~{n} h",
    "buyer.seller.replyDays": "~{n} j",
    "buyer.seller.safety": "Rencontrez-vous dans un lieu public et payez seulement une fois l’article en main. N’envoyez jamais d’acompte.",
    "auth.sheet.title": "Connectez-vous pour continuer",
    "auth.sheet.description": "10 secondes suffisent. Votre message est conservé et sera envoyé juste après.",
    "auth.sheet.google": "Continuer avec Google",
    "auth.sheet.emailPlaceholder": "Votre e-mail",
    "auth.sheet.passwordPlaceholder": "Mot de passe",
    "auth.sheet.magic": "Recevoir un lien de connexion",
    "auth.sheet.login": "Se connecter",
    "auth.sheet.usePassword": "J’ai un mot de passe",
    "auth.sheet.useMagic": "Se connecter sans mot de passe",
    "auth.sheet.magicSentTitle": "Vérifiez votre boîte mail",
    "auth.sheet.magicSentText": "Nous avons envoyé un lien de connexion à {email}. Ouvrez-le sur ce téléphone pour continuer.",
    "auth.sheet.noAccountHint": "Pas encore de compte ? Il sera créé automatiquement.",
    "auth.sheet.error": "Une erreur est survenue, veuillez réessayer",
    "nav.home": "Accueil",
    "nav.search": "Rechercher",
    "nav.sell": "Vendre",
    "nav.messages": "Messages",
    "nav.profile": "Profil",
    "nav.login": "Connexion",
    "card.noPhoto": "Pas de photo",
    "filters.title": "Filtres",
    "filters.priceRange": "Fourchette de prix (€)",
    "filters.anyCondition": "Tous les états",
    "filters.includeSold": "Inclure les articles vendus",
    "filters.nearMe": "Annonces près de moi",
    "filters.locating": "Localisation en cours…",
    "filters.show": "Voir {n} résultats",
    "filters.searchPlaceholder": "Rechercher…",
    "filters.allListings": "Toutes les annonces",
    "filters.newest": "Plus récentes",
    "filters.cityPlaceholder": "Ville ou commune…",
    "messages.typePlaceholder": "Écrire un message…",
    "messages.makeOffer": "Faire une offre",
    "messages.viewListing": "Voir l’annonce",
    "profile.saved": "Profil mis à jour",
    "profile.saveFailed": "Impossible d'enregistrer votre profil",
    "profile.showPhonePublic": "Afficher le numéro sur mes annonces",
    "profile.bio": "À propos de moi",
    "profile.bioPlaceholder": "Parlez de vous aux autres...",
    "profile.location": "Localisation",
    "profile.city": "Ville",
    "profile.country": "Pays",
    "profile.professionalAccount": "Compte professionnel",
    "profile.companyName": "Nom de l'entreprise",
    "profile.siret": "Numéro SIRET",
    "profile.website": "Site web",
    "profile.responseTime": "Temps de réponse",
    "profile.selectResponseTime": "Sélectionnez votre délai de réponse habituel",
    "profile.notSpecified": "Non spécifié",
    "profile.responseTime.1hour": "Moins d'une heure",
    "profile.responseTime.24hours": "Moins de 24 heures",
    "profile.responseTime.2days": "1-2 jours",
    "profile.responseTime.moreDays": "Plus de 2 jours",
    "profile.memberSince": "Membre depuis",
    "profile.responds": "Répond en",
    "profile.visitWebsite": "Visiter le site",
    "profile.listings": "Annonces",
    "profile.reviews": "avis",
    "profile.responseRate": "Taux de réponse",
    "profile.myListings": "Mes annonces",
    "profile.reviewsTab": "Avis",
    "profile.newListing": "Nouvelle annonce",
    "profile.noListings": "Pas encore d'annonces",
    "profile.noListingsDesc": "Commencez à vendre en créant votre première annonce",
    "profile.createListing": "Créer une annonce",
    "profile.noReviews": "Pas encore d'avis",
    "profile.noReviewsDesc": "Les avis apparaîtront ici lorsque les acheteurs laisseront des commentaires",
    "profile.reviewsComingSoon": "Fonctionnalité d'avis bientôt disponible",
    "profile.lastActive.unknown": "Vu récemment",
    "profile.lastActive.now": "En ligne",
    "profile.lastActive.hoursAgo": "Vu il y a",
    "profile.lastActive.yesterday": "Vu hier",
    "profile.lastActive.daysAgo": "Vu il y a",
    
    // Footer
    "footer.about": "À propos de LebonLux",
    "footer.aboutText": "LebonLux est la principale place de marché pour le Luxembourg et la Grande Région, connectant acheteurs et vendeurs dans un rayon de 200km.",
    "footer.quickLinks": "Liens rapides",
    "footer.support": "Support",
    "footer.legal": "Mentions légales",
    "footer.contact": "Nous contacter",
    "footer.help": "Centre d'aide",
    "footer.safety": "Conseils de sécurité",
    "footer.terms": "Conditions d'utilisation",
    "footer.privacy": "Politique de confidentialité",
    "footer.cookies": "Politique de cookies",
    "footer.copyright": "© {year} LebonLux. Tous droits réservés.",
    // Page introuvable
    "notFound.title": "Page introuvable",
    "notFound.description": "La page que vous cherchez n'existe pas ou a été déplacée.",
    "notFound.goHome": "Retour à l'accueil",
    "notFound.browseListings": "Parcourir les annonces",
    "notFound.goBack": "Retour",
    "listing.noReviewsYet": "Pas encore d'avis",
    "search.seeAllFor": "Voir tous les résultats pour",
    "search.noSuggestions": "Aucune correspondance. Lancez une recherche complète :"
  },
  
  de: {
    "messages.viewProfile": "Profil ansehen",
    "header.savedSearches": "Gespeicherte Suchen",
    "saved.kicker": "Deine Suchalarme",
    "saved.title": "Gespeicherte Suchen",
    "saved.subtitle": "Wir beobachten den Markt für dich: passende neue Anzeigen erscheinen hier und in deinem Posteingang.",
    "saved.count": "{n} gespeichert",
    "saved.totalNew": "{n} neue Anzeigen seit deinem letzten Besuch",
    "saved.new": "{n} neu",
    "saved.noNew": "Nichts Neues",
    "saved.freq.instant": "Sofort",
    "saved.freq.daily": "Tägliche Zusammenfassung",
    "saved.freq.off": "Aus",
    "saved.freq.instantHint": "E-Mail, sobald eine neue Anzeige passt (max. eine pro Stunde)",
    "saved.freq.dailyHint": "Eine Zusammenfassung jeden Morgen um 8:00 Uhr",
    "saved.freq.offHint": "Keine E-Mails, nur das Abzeichen auf dieser Seite",
    "saved.view": "Ergebnisse ansehen",
    "saved.rename": "Umbenennen",
    "saved.delete": "Löschen",
    "saved.deleteTitle": "Diese gespeicherte Suche löschen?",
    "saved.deleteText": "Du erhältst keine Benachrichtigungen mehr für „{name}“.",
    "saved.cancel": "Abbrechen",
    "saved.empty": "Noch keine gespeicherten Suchen",
    "saved.emptyText": "Starte eine Suche, tippe auf „Suche speichern“ und wir melden uns, wenn etwas Neues passt.",
    "saved.startSearching": "Suche starten",
    "saved.newSearch": "Neue Suche",
    "saved.updated": "Suche aktualisiert",
    "saved.deleted": "Suche gelöscht",
    "saved.failed": "Etwas ist schiefgelaufen, bitte erneut versuchen",
    "saved.allListings": "Alle Anzeigen",
    "saved.upTo": "Bis {n} €",
    "saved.from": "Ab {n} €",
    "saved.manage": "Suchen verwalten",
    "saved.signIn": "Melde dich an, um deine gespeicherten Suchen zu sehen",
    "home.latest.forYou": "Für Sie empfohlen",
    "feed.notInterested": "Kein Interesse",
    "feed.hidden": "Wir zeigen Ihnen weniger solche Anzeigen.",
    "feed.undo": "Rückgängig",
    "feed.why.similar_to_favourites": "Ähnlich wie Ihre Favoriten",
    "feed.why.viewed_subcategory": "Weil Sie ähnliche Artikel angesehen haben",
    "feed.why.favourite_category": "Aus einer Kategorie, die Sie verfolgen",
    "feed.why.near_you": "In Ihrer Nähe",
    "feed.why.new_and_popular": "Neu und beliebt",
    "feed.why.explore": "Mal etwas anderes",
    "profile.personalization": "Personalisierte Empfehlungen",
    "profile.personalizationHint": "Meine Aufrufe, Favoriten, Suchen und Nachrichten nutzen, um die Startseite für mich zu sortieren. Aus = derselbe Feed wie für alle.",
    "profile.clearHistory": "Meinen Empfehlungsverlauf löschen",
    "phoneVerify.badgeHint": "Dieses Mitglied hat per SMS-Code bestätigt, eine Mobilnummer zu kontrollieren. Das ist keine Identitätsprüfung und garantiert keine Transaktion.",
    "phoneVerify.title": "Telefonnummer bestätigen",
    "phoneVerify.subtitle": "Zur Sicherheit aller bestätigt jedes Mitglied einmalig eine Mobilnummer, bevor es Nachrichten sendet. Wir senden nur einen Code per SMS — Ihre Nummer bleibt privat.",
    "phoneVerify.phoneLabel": "Mobilnummer",
    "phoneVerify.sendCode": "Code senden",
    "phoneVerify.sending": "Wird gesendet…",
    "phoneVerify.codeSentTo": "Wir haben einen 6-stelligen Code gesendet an",
    "phoneVerify.codeLabel": "Code eingeben",
    "phoneVerify.verify": "Bestätigen",
    "phoneVerify.verifying": "Wird geprüft…",
    "phoneVerify.resend": "Code erneut senden",
    "phoneVerify.resendIn": "Erneut senden in {s}s",
    "phoneVerify.changeNumber": "Nummer ändern",
    "phoneVerify.successTitle": "Telefon bestätigt",
    "phoneVerify.successText": "Danke! Sie können jetzt Käufern und Verkäufern schreiben.",
    "phoneVerify.continue": "Weiter",
    "phoneVerify.required": "Bitte bestätigen Sie Ihre Telefonnummer, um Nachrichten zu senden.",
    "phoneVerify.mockHint": "Testmodus: Code 123456 verwenden",
    "phoneVerify.verifyButton": "Telefon bestätigen",
    "phoneVerify.verifiedLabel": "Telefon bestätigt",
    "phoneVerify.notVerifiedLabel": "Telefon nicht bestätigt",
    "phoneVerify.err.invalid_phone": "Diese Telefonnummer ist ungültig.",
    "phoneVerify.err.country_not_allowed": "Nur Nummern aus Luxemburg, Frankreich, Belgien, Deutschland, Portugal, Italien und Spanien werden akzeptiert.",
    "phoneVerify.err.mobile_required": "Bitte verwenden Sie eine Mobilnummer.",
    "phoneVerify.err.phone_already_used": "Diese Nummer ist bereits bei einem anderen Konto bestätigt.",
    "phoneVerify.err.incorrect_code": "Falscher Code. Noch {n} Versuche.",
    "phoneVerify.err.expired": "Dieser Code ist abgelaufen. Fordern Sie einen neuen an.",
    "phoneVerify.err.attempts_exhausted": "Zu viele Versuche. Fordern Sie einen neuen Code an.",
    "phoneVerify.err.resend_cooldown": "Bitte warten Sie kurz, bevor Sie einen neuen Code anfordern.",
    "phoneVerify.err.provider_error": "Die SMS konnte gerade nicht gesendet werden. Bitte versuchen Sie es gleich erneut.",
    "phoneVerify.err.generic": "Etwas ist schiefgelaufen. Bitte erneut versuchen.",
    "profile.standard": "Standard",
    "category.byCity": "Nach Stadt durchsuchen",
    "home.latest.discover": "Empfohlen",
    "filters.moreCriteria": "Weitere Kriterien ({count})",
    "filters.lessCriteria": "Weniger Kriterien",
    "auth.register.err.emailExists": "Diese E-Mail ist bereits registriert. Bitte melden Sie sich an.",
    "edit.title": "Anzeige bearbeiten",
    "edit.basicDetails": "Grundangaben",
    "edit.saving": "Wird gespeichert...",
    "edit.success": "Anzeige aktualisiert!",
    "edit.err.load": "Anzeige konnte nicht geladen werden",
    "edit.err.update": "Anzeige konnte nicht aktualisiert werden. Bitte erneut versuchen.",
    "auth.register.subtitle": "Erstellen Sie ein Konto, um zu kaufen und zu verkaufen.",
    "auth.register.passwordPlaceholder": "Passwort erstellen",
    "auth.register.req.length": "Mindestens 8 Zeichen",
    "auth.register.req.upper": "Ein Großbuchstabe",
    "auth.register.req.number": "Eine Zahl",
    "auth.register.err.terms": "Bitte akzeptieren Sie die Nutzungsbedingungen",
    "auth.register.err.password": "Das Passwort erfüllt nicht alle Anforderungen",
    "auth.register.err.failed": "Registrierung fehlgeschlagen. Bitte erneut versuchen.",
    "auth.register.err.google": "Google-Registrierung fehlgeschlagen",
    "auth.register.agree": "Ich akzeptiere die",
    "auth.register.termsLink": "Nutzungsbedingungen",
    "auth.register.and": "und die",
    "auth.register.privacyLink": "Datenschutzerklärung",
    "auth.register.creating": "Konto wird erstellt...",
    "auth.login.err.invalid": "E-Mail oder Passwort ungültig",
    "auth.login.err.google": "Google-Anmeldung fehlgeschlagen",
    "listing.ownerActions": "Ihre Anzeige verwalten",
    "myListings.actions.markSold": "Als verkauft markieren",
    "myListings.actions.reactivate": "Reaktivieren",
    "myListings.views": "Aufrufe",
    "myListings.sold.title": "Als verkauft markieren?",
    "myListings.sold.text": "„{title}“ wird als verkauft angezeigt. Unterhaltungen ohne angenommenes Angebot werden geschlossen. Sie können die Anzeige später reaktivieren.",
    "myListings.toast.sold": "Anzeige als verkauft markiert",
    "myListings.toast.deleted": "Anzeige gelöscht",
    "myListings.toast.reactivated": "Anzeige reaktiviert",
    "myListings.toast.failed": "Aktion fehlgeschlagen, bitte erneut versuchen",
    // Header
    "header.categories": "Kategorien",
    "header.searchPlaceholder": "Artikel suchen...",
    "header.login": "Anmelden",
    "header.signup": "Registrieren",
    "header.sell": "Verkaufen",
    
    // Navigation
    "nav.categories": "Kategorien",
    "nav.sell": "Artikel verkaufen",
    "nav.logout": "Abmelden",
    "nav.myProfile": "Mein Profil",
    "nav.myListings": "Meine Anzeigen",
    "nav.favorites": "Favoriten",
    "nav.messages": "Nachrichten",
    "nav.login": "Anmelden",
    "nav.signup": "Registrieren",
    "cond.new-with-tags": "Neu mit Etikett",
    "cond.excellent": "Ausgezeichnet",
    "cond.very-good": "Sehr gut",
    "cond.used": "Gebraucht",
    "filters.details": "Details",
    "filters.min": "Min",
    "filters.max": "Max",
    "filters.priceRange": "Preis",
    "filters.anyCondition": "Alle Zustände",
    "profile.tabSaved": "Gespeicherte Anzeigen",
    "profile.tabSearches": "Gespeicherte Suchen",
    "profile.tabSettings": "Einstellungen",
    "messages.sendFailed": "Deine Nachricht konnte nicht gesendet werden. Bitte erneut versuchen.",
    "messages.signIn": "Melde dich an, um Nachrichten zu sehen",
    "messages.noConversations": "Noch keine Unterhaltungen",
    "messages.startConversation": "Kontaktiere einen Verkäufer, um eine Unterhaltung zu starten",
    "messages.selectConversation": "Wähle eine Unterhaltung",
    "messages.chooseConversation": "Wähle eine bestehende Unterhaltung oder starte eine neue",
    "messages.attachFile": "Datei anhängen",
    "messages.attachImage": "Bild anhängen",
    "messages.searchPlaceholder": "Unterhaltungen suchen…",
    "messages.markAllRead": "Alle als gelesen markieren",
    "report.title": "Melden",
    "report.description": "Warum meldest du das?",
    "report.listingDescription": "Warum meldest du diese Anzeige?",
    "report.reason.spam": "Spam oder irreführend",
    "report.reason.inappropriate": "Unangemessener Inhalt",
    "report.reason.scam": "Betrug",
    "report.reason.harassment": "Belästigung oder Missbrauch",
    "report.reason.counterfeit": "Fälschung",
    "report.reason.other": "Sonstiges",
    "report.additionalInfo": "Zusätzliche Informationen (optional)",
    "report.additionalPlaceholder": "Gib weitere Details zu dieser Meldung an…",
    "report.submit": "Meldung senden",
    "report.submitting": "Wird gesendet…",
    "report.success": "Meldung gesendet. Wir prüfen sie in Kürze.",
    "filters.category": "Kategorie",
    "filters.allCategories": "Alle Kategorien",
    "filters.subcategory": "Unterkategorie",
    "filters.allSubcategories": "Alle Unterkategorien",
    "filters.condition": "Zustand",
    "filters.location": "Standort",
    "filters.yourLocation": "Dein Standort",
    "filters.transaction": "Transaktionsart",
    "filters.saleOrRent": "Kauf oder Miete",
    "filters.any": "Alle",
    "filters.forSale": "Zu verkaufen",
    "filters.forRent": "Zu vermieten",
    "filters.realEstate": "Immobilien-Filter",
    "filters.vehicles": "Fahrzeug-Filter",
    "filters.surface": "Fläche (m²)",
    "filters.minRooms": "Zimmer min.",
    "filters.brand": "Marke",
    "filters.anyBrand": "Alle Marken",
    "filters.year": "Baujahr (ab)",
    "filters.anyYear": "Alle Baujahre",
    "filters.mileage": "Max. Kilometer",
    "filters.anyMileage": "Alle Kilometerstände",
    "filters.fuel": "Kraftstoff",
    "filters.anyFuel": "Alle Kraftstoffe",
    "filters.search": "Suchen",
    "filters.saveSearch": "Suche speichern",
    "filters.saveFailed": "Suche konnte nicht gespeichert werden. Bitte erneut versuchen.",
    "filters.list": "Liste",
    "filters.map": "Karte",
    "filters.searchName": "Name der Suche",
    "filters.searchNamePlaceholder": "z. B. Wohnungen unter 1.500 €",
    "filters.emailAlerts": "E-Mail-Benachrichtigungen",
    "filters.emailAlertsHint": "Benachrichtigung bei neuen passenden Anzeigen",
    "cond.new": "Neu",
    "cond.like-new": "Wie neu",
    "cond.good": "Gut",
    "cond.fair": "Akzeptabel",
    "cond.poor": "Gebraucht",
    "category.notFound": "Kategorie nicht gefunden",
    "category.notFoundText": "Diese Kategorie existiert nicht.",
    "category.backHome": "Zur Startseite",
    "category.empty": "Keine Anzeigen in dieser Kategorie",
    "myListings.signIn": "Melde dich an, um deine Anzeigen zu sehen",
    "myListings.signInText": "Verwalte alle deine Anzeigen an einem Ort",
    "myListings.shipping": "Versand",
    "auth.signIn": "Anmelden",
    "footer.serving": "Aktiv in:",
    "footer.howItWorks": "So funktioniert's",
    "footer.faq": "FAQ",
    "footer.aboutUs": "Über uns",
    "footer.careers": "Karriere",
    "country.luxembourg": "Luxemburg",
    "country.germany": "Deutschland",
    "country.france": "Frankreich",
    "country.belgium": "Belgien",
    "profile.logout": "Abmelden",
    "profile.noSaved": "Noch keine gespeicherten Anzeigen",
    "profile.noSavedText": "Speichere Anzeigen über das Herz-Symbol",
    "profile.noSearches": "Noch keine gespeicherten Suchen",
    "profile.notifications": "Benachrichtigungen",
    "profile.notificationsText": "Lege fest, wie du benachrichtigt wirst",
    "profile.emailNotifications": "E-Mail-Benachrichtigungen",
    "profile.accountInfo": "Kontoinformationen",
    "profile.accountInfoText": "Deine Kontodaten",
    "profile.email": "E-Mail",
    "profile.accountStatus": "Kontostatus",
    "explore.savedSearches": "Deine gespeicherten Suchen",
    "search.trending": "Beliebte Suchen",
    "search.recentlyViewed": "Zuletzt angesehen",
    "search.clearRecent": "Löschen",
    "messages.repliesIn": "Antwortet in {time}",
    "messages.replyRateShort": "{rate} % Antwortrate",
    "messages.memberSince": "Mitglied seit {date}",
    "nav.allCategories": "Alle Kategorien",
    "nav.admin": "Admin",
    "browser.viewAll": "Alles in {name} ansehen",
    "browser.ads": "Anzeigen",
    "browser.ad": "Anzeige",
    "header.favorites": "Favoriten",
    "header.messages": "Nachrichten",
    "header.myListings": "Meine Anzeigen",
    "header.profile": "Profil",
    "header.logout": "Abmelden",
    "header.tagline": "Luxemburg & Umgebung | Lokal kaufen und verkaufen im Umkreis von 200km",
    
    // Homepage
    "home.hero.title": "Kaufen & Verkaufen in",
    "home.hero.highlight": "Luxemburg & Umgebung",
    "home.hero.subtitle": "Lokal kaufen und verkaufen in Luxemburg und den Nachbarstädten. Kostenlose Anzeigen, 4 Sprachen, Übergabe vor Ort.",
    "home.search.placeholder": "Wonach suchen Sie?",
    "home.search.allLocations": "Alle Standorte",
    "home.search.button": "Suchen",
    "home.search.minPrice": "Min €",
    "home.search.maxPrice": "Max €",
    "home.search.filters": "Filter",
    "home.search.advanced": "Erweiterte Suche",
    "home.search.clearFilters": "Filter löschen",
    "home.search.applyFilters": "Anwenden",
    "home.search.clearAll": "Alle löschen",
    "home.search.filterBy": "Filtern nach",
    "home.search.selectOption": "Auswählen",
    "home.search.all": "Alle",
    "home.search.results": "Ergebnisse",
    "home.search.resultsIn": "in",
    "home.popular": "Beliebt:",
    "home.cta.title": "Zeit zu verkaufen!",
    "home.cta.subtitle": "Schalten Sie Ihre Anzeige kostenlos und erreichen Sie tausende Käufer",
    "home.cta.button": "Anzeige aufgeben",
    "home.noResults.title": "Keine Anzeigen gefunden",
    "home.noResults.subtitle": "Keine Anzeigen entsprechen Ihren Kriterien",
    "home.noResults.beFirst": "Seien Sie der Erste, der eine Anzeige veröffentlicht!",
    "home.stats.listings": "Aktive Anzeigen",
    "home.stats.users": "Registrierte Mitglieder",
    "home.stats.countries": "Länder",
    "home.mapSearch": "Kartensuche",
    "home.viewOnMap": "Auf Karte ansehen",
    "home.map": "Karte",
    "home.categories.title": "Nach Kategorie durchsuchen",
    "home.categories.viewAll": "Alle anzeigen",
    "home.featured.title": "Empfohlene Anzeigen",
    "home.featured.seeAll": "Alle anzeigen",
    "home.latest.title": "Empfohlene Anzeigen",
    "home.latest.category": "Kategorie",
    "home.latest.newest": "Neueste zuerst",
    "home.latest.priceLow": "Preis: aufsteigend",
    "home.latest.priceHigh": "Preis: absteigend",
    "home.latest.popular": "Beliebteste",
    "home.latest.loadMore": "Mehr Anzeigen laden",
    "home.latest.noListings": "Keine Anzeigen gefunden",
    "home.latest.createFirst": "Erste Anzeige erstellen",
    "home.why.title": "Warum LebonLux wählen?",
    "home.why.verified.title": "Verifizierte Verkäufer",
    "home.why.verified.desc": "Kaufen Sie mit Vertrauen von verifizierten Verkäufern mit Bewertungen.",
    "home.why.local.title": "Lokal & grenzüberschreitend",
    "home.why.local.desc": "Finden Sie Angebote in Luxemburg und den Nachbarregionen in 4 Ländern.",
    "home.why.ai.title": "KI-gestützte Anzeigen",
    "home.why.ai.desc": "Verkaufen Sie schneller mit automatischer Kategorisierung und intelligenten Preisvorschlägen.",
    
    // Categories - Unified with Leboncoin
    "category.vehicules": "Fahrzeuge",
    "category.immobilier": "Immobilien",
    "category.vacances": "Ferienvermietungen",
    "category.emploi": "Stellenangebote",
    "category.mode": "Mode",
    "category.maison-jardin": "Haus & Garten",
    "category.famille": "Familie",
    "category.electronique": "Elektronik",
    "category.loisirs": "Freizeit",
    "category.services": "Dienstleistungen",
    "category.materiel-pro": "Profi-Ausstattung",
    "category.art": "Kunst",
    "category.autres": "Sonstiges",
    "category.ads": "Anzeigen",
    "category.listingsFound": "{count} Anzeigen gefunden",
    "category.noListingsFound": "Keine Anzeigen in dieser Kategorie",
    "category.loadMore": "Weitere Anzeigen laden",
    "category.all": "Alle",
    "category.allConditions": "Alle Zustände",
    "category.condition": "Zustand",
    "category.filters": "Filter",
    "category.clearAll": "Alle löschen",
    "category.clearAllFilters": "Alle Filter löschen",
    "category.clearFilters": "Filter löschen",
    "sort.newest": "Neueste zuerst",
    "sort.priceLow": "Preis: Niedrig nach Hoch",
    "sort.priceHigh": "Preis: Hoch nach Niedrig",
    "sort.popular": "Am beliebtesten",
    "sort.oldest": "Älteste zuerst",
    "sort.label": "Sortieren nach",
    "followup.label": "Kurze Nachfrage",
    "followup.yes": "Ja, weiterhin interessiert",
    "followup.no": "Nein, danke",
    "followup.answeredYes": "Deine Antwort: weiterhin interessiert 👍",
    "followup.answeredNo": "Deine Antwort: nicht mehr interessiert",
    "followup.sellerHint": "Wir haben den Käufer gefragt, ob er noch interessiert ist.",
    "sold.prompt.title": "Angebot angenommen!",
    "sold.prompt.description": "„{title}“ als verkauft markieren? Andere Käufer werden informiert, dieser Chat bleibt für die Übergabe offen.",
    "sold.prompt.hint": "Die Anzeige bleibt 30 Tage mit dem Badge „Verkauft“ sichtbar.",
    "sold.prompt.confirm": "Als verkauft markieren",
    "sold.prompt.later": "Später",
    "sold.prompt.done": "Anzeige als verkauft markiert 🎉",
    "sold.banner.text": "Du hast ein Angebot für „{title}“ angenommen.",
    "sold.banner.cta": "Als verkauft markieren",
    "listing.sold": "Verkauft",
    "messages.closedSold": "Unterhaltung geschlossen — die Anzeige wurde verkauft",
    "safety.nudge": "Bleib sicher: Treffen an einem öffentlichen Ort, erst bei Übergabe zahlen, keine Anzahlung und keine Zahlung außerhalb von LebonLux.",
    
    // Create Listing
    "create.title": "Anzeige erstellen",
    "create.step.photos": "Fotos",
    "create.step.details": "Details",
    "create.step.price": "Preis & Standort",
    "create.photos.title": "Fotos hinzufügen",
    "create.photos.subtitle": "Fügen Sie bis zu 10 Fotos hinzu. Das erste Foto wird das Titelbild.",
    "create.photos.upload": "Klicken Sie zum Hochladen",
    "create.photos.dragDrop": "oder per Drag & Drop",
    "create.photos.cover": "Titelbild",
    "create.photos.optional": "Fotos sind optional - Sie können sie später hinzufügen",
    "create.photos.skipAI": "Überspringen und manuell kategorisieren",
    "create.ai.title": "KI-gestütztes Ausfüllen",
    "create.ai.subtitle": "Lassen Sie unsere KI Ihre Fotos analysieren, um automatisch Kategorie, Titel, Beschreibung und Preis vorzuschlagen.",
    "create.ai.analyze": "Fotos analysieren",
    "create.ai.analyzing": "Analysiere...",
    "create.ai.category": "Vorgeschlagene Kategorie",
    "create.ai.titleSuggestion": "Vorgeschlagener Titel",
    "create.ai.retailValue": "Geschätzter Neupreis",
    "create.ai.suggestedPrice": "Empfohlener Verkaufspreis",
    "create.ai.confidence": "Konfidenz",
    "create.ai.apply": "Vorschläge übernehmen",
    "create.ai.suggestPrice": "KI-Preis",
    "create.ai.calculating": "Berechne...",
    "create.ai.suggestedRange": "KI-empfohlene Preisspanne",
    "create.ai.priceError": "Bitte füllen Sie zuerst Titel, Kategorie und Zustand aus",
    "create.ai.priceSuggestionFailed": "KI-Preisvorschlag konnte nicht abgerufen werden. Bitte geben Sie den Preis manuell ein.",
    "create.details.title": "Artikeldetails",
    "create.details.subtitle": "Beschreiben Sie Ihren Artikel für Käufer.",
    "create.details.itemTitle": "Titel",
    "create.details.titlePlaceholder": "z.B. iPhone 14 Pro - Ausgezeichneter Zustand",
    "create.details.description": "Beschreibung",
    "create.details.descPlaceholder": "Beschreiben Sie Ihren Artikel - Zustand, Eigenschaften, Verkaufsgrund...",
    "create.details.category": "Kategorie",
    "create.details.selectCategory": "Kategorie auswählen",
    "create.details.subcategory": "Unterkategorie",
    "create.details.selectSubcategory": "Unterkategorie auswählen",
    "create.details.condition": "Zustand",
    "create.details.selectCondition": "Zustand auswählen",
    "create.details.attributes": "Zusätzliche Details",
    "create.price.title": "Preis & Standort",
    "create.price.subtitle": "Legen Sie Ihren Preis fest und bestätigen Sie Ihren Standort.",
    "create.price.type": "Preistyp",
    "create.price.fixed": "Festpreis",
    "create.price.negotiable": "Verhandelbar",
    "create.price.free": "Kostenlos",
    "create.price.amount": "Preis (€)",
    "create.price.retailHint": "Neupreis: {value} €",
    "create.location.title": "Standort",
    "create.location.select": "Wählen Sie Ihren Standort",
    "create.location.change": "Ändern",
    "create.shipping.title": "Versand verfügbar",
    "create.shipping.subtitle": "Bieten Sie den Versand an Käufer an",
    "create.preview": "Vorschau",
    "create.preview.title": "Ihr Anzeigentitel",
    "create.preview.selectLocation": "Standort auswählen",
    "create.nav.back": "Zurück",
    "create.nav.continue": "Weiter",
    "create.nav.publish": "Anzeige veröffentlichen",
    "create.nav.publishing": "Wird veröffentlicht...",
    "create.location.popup.title": "Wo befinden Sie sich?",
    "create.location.popup.detect": "Meinen aktuellen Standort verwenden",
    "create.location.popup.detecting": "Standort wird ermittelt...",
    "create.location.popup.manual": "Oder manuell eingeben",
    "create.location.popup.search": "Stadt suchen...",
    "create.location.popup.hint": "Wir bedienen Luxemburg und die umliegenden Regionen im Umkreis von 200km",
    
    // My Listings
    "myListings.title": "Meine Anzeigen",
    "myListings.count": "{count} aktive Anzeigen",
    "myListings.newListing": "Neue Anzeige",
    "myListings.empty.title": "Noch keine Anzeigen",
    "myListings.empty.subtitle": "Beginnen Sie zu verkaufen, indem Sie Ihre erste Anzeige erstellen",
    "myListings.empty.button": "Erste Anzeige erstellen",
    "myListings.actions.view": "Ansehen",
    "myListings.actions.edit": "Bearbeiten",
    "myListings.actions.delete": "Löschen",
    "myListings.delete.title": "Anzeige löschen",
    "myListings.delete.whyDelete": "Warum löschen Sie diese Anzeige?",
    "myListings.delete.confirm": "Sind Sie sicher, dass Sie \"{title}\" löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.",
    "myListings.delete.cancel": "Abbrechen",
    "myListings.delete.deleting": "Wird gelöscht...",
    "myListings.delete.otherPlaceholder": "Bitte geben Sie den Grund an...",
    "myListings.delete.congrats": "Herzlichen Glückwunsch zum Verkauf! Danke, dass Sie LebonLux nutzen.",
    "myListings.deleteReason.soldHere": "Auf LebonLux verkauft",
    "myListings.deleteReason.soldElsewhere": "Woanders verkauft",
    "myListings.deleteReason.noLongerSelling": "Möchte nicht mehr verkaufen",
    "myListings.deleteReason.other": "Anderer Grund",
    
    // Favorites
    "favorites.title": "Meine Favoriten",
    "favorites.savedItems": "gespeicherte Artikel",
    "favorites.signIn": "Melden Sie sich an, um Ihre Favoriten zu sehen",
    "favorites.signInSubtitle": "Speichern Sie Artikel, die Sie mögen, und kommen Sie jederzeit darauf zurück",
    "favorites.empty": "Noch keine Favoriten",
    "favorites.emptySubtitle": "Beginnen Sie, Artikel zu speichern, indem Sie auf das Herzsymbol klicken",
    "favorites.browse": "Anzeigen durchsuchen",
    
    // Messages
    "messages.title": "Nachrichten",
    "messages.search": "Konversationen suchen...",
    "messages.empty": "Noch keine Konversationen",
    "messages.emptyHint": "Starten Sie eine Konversation, indem Sie einen Verkäufer kontaktieren",
    "messages.select": "Wählen Sie eine Konversation",
    "messages.selectHint": "Wählen Sie aus Ihren bestehenden Konversationen oder starten Sie eine neue",
    "messages.responseTime": "Antwortet normalerweise innerhalb einer Stunde",
    "messages.report": "Melden",
    "messages.deleteConversation": "Konversation löschen",
    "messages.inputPlaceholder": "Nachricht eingeben...",
    
    // Auth
    "auth.login.title": "Willkommen zurück! Melden Sie sich an, um fortzufahren.",
    "auth.login.google": "Mit Google fortfahren",
    "auth.login.or": "oder",
    "auth.login.email": "E-Mail",
    "auth.login.emailPlaceholder": "ihre@email.com",
    "auth.login.password": "Passwort",
    "auth.login.forgot": "Passwort vergessen?",
    "auth.login.button": "Anmelden",
    "auth.login.noAccount": "Noch kein Konto?",
    "auth.login.signup": "Registrieren",
    "auth.register.title": "Erstellen Sie Ihr Konto",
    "auth.register.name": "Vollständiger Name",
    "auth.register.namePlaceholder": "Max Mustermann",
    "auth.register.button": "Konto erstellen",
    "auth.register.hasAccount": "Bereits ein Konto?",
    "auth.register.login": "Anmelden",
    "auth.register.terms": "Mit der Registrierung akzeptieren Sie unsere AGB und Datenschutzrichtlinie",
    "auth.email": "E-Mail",
    "auth.emailPlaceholder": "ihre@email.com",
    
    // Forgot Password
    "forgot.title": "Passwort vergessen?",
    "forgot.subtitle": "Geben Sie Ihre E-Mail ein und wir senden Ihnen einen Link zum Zurücksetzen.",
    "forgot.sendLink": "Link senden",
    "forgot.sending": "Wird gesendet...",
    "forgot.backToLogin": "Zurück zur Anmeldung",
    "forgot.success.title": "Überprüfen Sie Ihre E-Mails",
    "forgot.success.message": "Falls ein Konto mit dieser E-Mail existiert, haben wir Ihnen einen Link gesendet.",
    "forgot.success.checkSpam": "Nicht gefunden? Überprüfen Sie Ihren Spam-Ordner.",
    
    // Reset Password
    "reset.title": "Passwort zurücksetzen",
    "reset.subtitle": "Geben Sie Ihr neues Passwort ein für",
    "reset.newPassword": "Neues Passwort",
    "reset.newPasswordPlaceholder": "Neues Passwort eingeben",
    "reset.confirmPassword": "Passwort bestätigen",
    "reset.confirmPasswordPlaceholder": "Neues Passwort bestätigen",
    "reset.resetButton": "Zurücksetzen",
    "reset.resetting": "Wird zurückgesetzt...",
    "reset.verifying": "Link wird überprüft...",
    "reset.passwordMismatch": "Passwörter stimmen nicht überein",
    "reset.passwordTooShort": "Passwort muss mindestens 6 Zeichen haben",
    "reset.invalidToken.title": "Ungültiger oder abgelaufener Link",
    "reset.invalidToken.message": "Dieser Link ist ungültig oder abgelaufen. Bitte fordern Sie einen neuen an.",
    "reset.requestNewLink": "Neuen Link anfordern",
    "reset.success.title": "Passwort zurückgesetzt!",
    "reset.success.message": "Ihr Passwort wurde erfolgreich zurückgesetzt. Sie können sich jetzt anmelden.",
    "reset.goToLogin": "Zur Anmeldung",
    
    // Listing Detail
    "listing.contact": "Verkäufer kontaktieren",
    "listing.sendMessage": "Nachricht senden",
    "listing.messagePlaceholder": "Hallo, ich interessiere mich für diesen Artikel...",
    "listing.favorite": "Zu Favoriten hinzufügen",
    "listing.share": "Teilen",
    "listing.save": "Speichern",
    "listing.report": "Anzeige melden",
    "listing.shipping": "Versand verfügbar",
    "listing.shippingPickupOnly": "Nur Abholung",
    "listing.condition": "Zustand",
    "listing.location": "Standort",
    "listing.posted": "Veröffentlicht",
    "listing.views": "Aufrufe",
    "listing.saves": "Speicherungen",
    "listing.daysAgo": "Tagen",
    "listing.seller": "Verkäufer",
    "listing.sellerInfo": "Verkäuferinformationen",
    "listing.memberSince": "Mitglied seit",
    "listing.viewProfile": "Profil ansehen",
    "listing.otherListings": "Weitere Anzeigen dieses Verkäufers",
    "listing.similar": "Ähnliche Anzeigen",
    "listing.description": "Beschreibung",
    "listing.details": "Details",
    "listing.category": "Kategorie",
    "listing.subcategory": "Unterkategorie",
    "listing.safetyTips": "Sicherheitstipps:",
    "listing.safetyTip1": "Treffen Sie sich an öffentlichen Orten",
    "listing.safetyTip2": "Prüfen Sie den Artikel vor der Zahlung",
    "listing.safetyTip3": "Zahlen Sie erst nach Erhalt des Artikels",
    "listing.reportListing": "Anzeige melden",
    "listing.translating": "Übersetzen...",
    "listing.translated": "Übersetzt",
    "listing.translate": "Übersetzen",
    "listing.noDescription": "Keine Beschreibung vorhanden.",
    "listing.locationPrivacy": "Standort auf Stadt-/Ortsebene für Datenschutz angezeigt",
    "listing.reviews": "Bewertungen",
    "listing.verifiedSeller": "Verkäufer mit bestätigter Telefonnummer",
    "listing.soldMessage": "Dieser Artikel wurde verkauft",
    "listing.soldSubtext": "Kontakt- und Speicheroptionen sind nicht mehr verfügbar",
    
    // Real Estate Details
    "realEstate.propertyDetails": "Objektdetails",
    "realEstate.livingArea": "Wohnfläche",
    "realEstate.totalRooms": "Zimmeranzahl",
    "realEstate.bedrooms": "Schlafzimmer",
    "realEstate.bathrooms": "Badezimmer",
    "realEstate.landArea": "Grundstücksfläche",
    "realEstate.pricePerSqm": "Preis pro m²",
    "realEstate.energyDiagnostics": "Energiediagnose",
    "realEstate.dpe": "Energieeffizienz (DPE)",
    "realEstate.ges": "Treibhausgasemissionen (GES)",
    "realEstate.energyConsumption": "Energieverbrauchsklasse",
    "realEstate.co2Emissions": "CO₂-Emissionsklasse",
    "realEstate.notSpecified": "Nicht angegeben",
    "realEstate.energyNote": "Energieklassen beeinflussen den Immobilienwert und die Vermietbarkeit. Immobilien der Klassen F oder G können in Luxemburg und Frankreich Mietbeschränkungen unterliegen.",
    "realEstate.buildingInfo": "Gebäudeinformationen",
    "realEstate.floor": "Etage",
    "realEstate.yearBuilt": "Baujahr",
    "realEstate.heating": "Heizung",
    "realEstate.features": "Ausstattung & Merkmale",
    "realEstate.parking": "Parkplatz",
    "realEstate.furnished": "Möbliert",
    "realEstate.balcony": "Balkon",
    "realEstate.terrace": "Terrasse",
    "realEstate.garden": "Garten",
    "realEstate.pool": "Pool",
    "realEstate.elevator": "Aufzug",
    "realEstate.cellar": "Keller",
    "realEstate.propertyType": "Objekttyp",
    
    // Common
    "common.loading": "Lädt...",
    "common.sending": "Wird gesendet...",
    "common.error": "Ein Fehler ist aufgetreten",
    "common.retry": "Erneut versuchen",
    "common.save": "Speichern",
    "common.cancel": "Abbrechen",
    "common.delete": "Löschen",
    "common.edit": "Bearbeiten",
    "common.close": "Schließen",
    "common.yes": "Ja",
    "common.no": "Nein",
    "common.free": "Kostenlos",
    "common.negotiable": "Verhandelbar",
    "common.today": "Heute",
    "common.yesterday": "Gestern",
    "common.daysAgo": "vor {days} Tagen",
    "common.justNow": "Gerade eben",
    "common.hoursAgo": "vor {hours}h",
    "common.saving": "Speichert...",
    "common.saveChanges": "Änderungen speichern",
    
    // Profile
    "profile.signInRequired": "Melden Sie sich an, um Ihr Profil zu sehen",
    "profile.editProfile": "Profil bearbeiten",
    "profile.verified": "Telefon bestätigt",
    "profile.basicInfo": "Grundinformationen",
    "profile.name": "Name",
    "profile.phone": "Telefonnummer",
    "search.noResultsFor": "Keine Ergebnisse für „{q}“",
    "search.noListings": "Keine Anzeigen",
    "search.tryDifferent": "Versuchen Sie andere Suchbegriffe oder Filter",
    "search.clearFilters": "Filter löschen",
    "search.searching": "Suche…",
    "search.items": "{n} Anzeigen",
    "badge.new": "Neu",
    "badge.priceDrop": "Preis gesenkt",
    "badge.shipping": "Versand möglich",
    "badge.saves": "{n}× gemerkt",
    "badge.savesLong": "{n} Personen haben diese Anzeige gemerkt",
    "alerts.title": "Wenig Ergebnisse? Lassen Sie sich benachrichtigen",
    "alerts.text": "Wir mailen Ihnen, sobald eine neue Anzeige zu dieser Suche passt.",
    "alerts.cta": "Suchalarm erstellen",
    "alerts.created": "Suchalarm erstellt — wir informieren Sie über neue Treffer",
    "alerts.exists": "Sie haben bereits einen Suchalarm für diese Suche",
    "alerts.manage": "Meine Suchalarme",
    "alerts.login": "Anmelden, um den Suchalarm zu erstellen — Ihre Suche bleibt gespeichert",
    "profile.replyRate": "Antwortrate",
    "profile.replyTime": "Antwortet in",
    "profile.stats.sold": "Verkauft",
    "buyer.contact": "Verkäufer kontaktieren",
    "buyer.contactPrice": "Verkäufer kontaktieren • {price}",
    "buyer.send": "Nachricht senden",
    "buyer.dialogTitle": "Dem Verkäufer schreiben",
    "buyer.messagePlaceholder": "Hallo, ist der Artikel noch verfügbar?",
    "buyer.quick.available": "Noch verfügbar?",
    "buyer.quick.lastPrice": "Letzter Preis?",
    "buyer.quick.visit": "Kann ich vorbeikommen?",
    "buyer.quick.delivery": "Versand möglich?",
    "buyer.offer.cta": "Preisvorschlag machen",
    "buyer.offer.title": "Ihr Angebot",
    "buyer.offer.hint": "Der Verkäufer kann im Chat annehmen oder ablehnen.",
    "buyer.offer.send": "Angebot von {amount} € senden",
    "buyer.offer.accept": "Annehmen",
    "buyer.offer.decline": "Ablehnen",
    "buyer.offer.pending": "Angebot offen",
    "buyer.offer.accepted": "Angebot angenommen",
    "buyer.offer.declined": "Angebot abgelehnt",
    "buyer.offer.yours": "Ihr Angebot",
    "buyer.sentToast": "Nachricht gesendet — der Verkäufer wurde benachrichtigt",
    "buyer.savedDraft": "Melden Sie sich an, um die Nachricht zu senden — wir haben sie gespeichert",
    "buyer.seller.replyRate": "Antwortrate",
    "buyer.seller.replyTime": "Antwortet in",
    "buyer.seller.listings": "Anzeigen",
    "buyer.seller.memberSince": "Mitglied seit {date}",
    "buyer.seller.call": "Verkäufer anrufen",
    "buyer.seller.replyMinutes": "~{n} Min",
    "buyer.seller.replyHours": "~{n} Std",
    "buyer.seller.replyDays": "~{n} T",
    "buyer.seller.safety": "Treffen Sie sich an einem öffentlichen Ort und zahlen Sie erst, wenn Sie den Artikel in der Hand haben. Nie eine Anzahlung senden.",
    "auth.sheet.title": "Anmelden, um fortzufahren",
    "auth.sheet.description": "Dauert 10 Sekunden. Ihre Nachricht bleibt gespeichert und wird danach gesendet.",
    "auth.sheet.google": "Mit Google fortfahren",
    "auth.sheet.emailPlaceholder": "Ihre E-Mail",
    "auth.sheet.passwordPlaceholder": "Passwort",
    "auth.sheet.magic": "Anmeldelink senden",
    "auth.sheet.login": "Anmelden",
    "auth.sheet.usePassword": "Ich habe ein Passwort",
    "auth.sheet.useMagic": "Ohne Passwort anmelden",
    "auth.sheet.magicSentTitle": "Prüfen Sie Ihr Postfach",
    "auth.sheet.magicSentText": "Wir haben einen Anmeldelink an {email} gesendet. Öffnen Sie ihn auf diesem Gerät.",
    "auth.sheet.noAccountHint": "Noch kein Konto? Es wird automatisch erstellt.",
    "auth.sheet.error": "Etwas ist schiefgelaufen, bitte erneut versuchen",
    "nav.home": "Start",
    "nav.search": "Suchen",
    "nav.sell": "Verkaufen",
    "nav.messages": "Nachrichten",
    "nav.profile": "Profil",
    "nav.login": "Anmelden",
    "card.noPhoto": "Kein Foto",
    "filters.title": "Filter",
    "filters.priceRange": "Preisspanne (€)",
    "filters.anyCondition": "Jeder Zustand",
    "filters.includeSold": "Verkaufte Artikel anzeigen",
    "filters.nearMe": "Anzeigen in meiner Nähe",
    "filters.locating": "Standort wird ermittelt…",
    "filters.show": "{n} Ergebnisse anzeigen",
    "filters.searchPlaceholder": "Suchen…",
    "filters.allListings": "Alle Anzeigen",
    "filters.newest": "Neueste zuerst",
    "filters.cityPlaceholder": "Stadt oder Gemeinde…",
    "messages.typePlaceholder": "Nachricht schreiben…",
    "messages.makeOffer": "Preisvorschlag",
    "messages.viewListing": "Anzeige ansehen",
    "profile.saved": "Profil aktualisiert",
    "profile.saveFailed": "Profil konnte nicht gespeichert werden",
    "profile.showPhonePublic": "Telefonnummer in meinen Anzeigen anzeigen",
    "profile.bio": "Über mich",
    "profile.bioPlaceholder": "Erzählen Sie anderen von sich...",
    "profile.location": "Standort",
    "profile.city": "Stadt",
    "profile.country": "Land",
    "profile.professionalAccount": "Geschäftskonto",
    "profile.companyName": "Firmenname",
    "profile.siret": "SIRET-Nummer",
    "profile.website": "Webseite",
    "profile.responseTime": "Antwortzeit",
    "profile.selectResponseTime": "Wählen Sie Ihre typische Antwortzeit",
    "profile.notSpecified": "Nicht angegeben",
    "profile.responseTime.1hour": "Weniger als 1 Stunde",
    "profile.responseTime.24hours": "Weniger als 24 Stunden",
    "profile.responseTime.2days": "1-2 Tage",
    "profile.responseTime.moreDays": "Mehr als 2 Tage",
    "profile.memberSince": "Mitglied seit",
    "profile.responds": "Antwortet in",
    "profile.visitWebsite": "Webseite besuchen",
    "profile.listings": "Anzeigen",
    "profile.reviews": "Bewertungen",
    "profile.responseRate": "Antwortrate",
    "profile.myListings": "Meine Anzeigen",
    "profile.reviewsTab": "Bewertungen",
    "profile.newListing": "Neue Anzeige",
    "profile.noListings": "Noch keine Anzeigen",
    "profile.noListingsDesc": "Beginnen Sie mit dem Verkaufen, indem Sie Ihre erste Anzeige erstellen",
    "profile.createListing": "Anzeige erstellen",
    "profile.noReviews": "Noch keine Bewertungen",
    "profile.noReviewsDesc": "Bewertungen erscheinen hier, sobald Käufer Feedback hinterlassen",
    "profile.reviewsComingSoon": "Bewertungsfunktion kommt bald",
    "profile.lastActive.unknown": "Kürzlich gesehen",
    "profile.lastActive.now": "Jetzt online",
    "profile.lastActive.hoursAgo": "Zuletzt gesehen vor",
    "profile.lastActive.yesterday": "Gestern gesehen",
    "profile.lastActive.daysAgo": "Zuletzt gesehen vor",
    
    // Footer
    "footer.about": "Über LebonLux",
    "footer.aboutText": "LebonLux ist der führende Marktplatz für Luxemburg und die Großregion und verbindet Käufer und Verkäufer im Umkreis von 200km.",
    "footer.quickLinks": "Schnelllinks",
    "footer.support": "Support",
    "footer.legal": "Rechtliches",
    "footer.contact": "Kontakt",
    "footer.help": "Hilfe-Center",
    "footer.safety": "Sicherheitstipps",
    "footer.terms": "Nutzungsbedingungen",
    "footer.privacy": "Datenschutz",
    "footer.cookies": "Cookie-Richtlinie",
    "footer.copyright": "© {year} LebonLux. Alle Rechte vorbehalten.",
    // Seite nicht gefunden
    "notFound.title": "Seite nicht gefunden",
    "notFound.description": "Die gesuchte Seite existiert nicht oder wurde verschoben.",
    "notFound.goHome": "Zurück zur Startseite",
    "notFound.browseListings": "Anzeigen durchsuchen",
    "notFound.goBack": "Zurück",
    "listing.noReviewsYet": "Noch keine Bewertungen",
    "search.seeAllFor": "Alle Ergebnisse anzeigen für",
    "search.noSuggestions": "Keine Treffer. Versuchen Sie die vollständige Suche:"
  },

  lb: {
    "messages.viewProfile": "Profil kucken",
    "header.savedSearches": "Gespäichert Sichen",
    "saved.kicker": "Är Alarmer",
    "saved.title": "Gespäichert Sichen",
    "saved.subtitle": "Mir behalen de Maart fir Iech am A: nei passend Annoncen erschéngen hei an an Ärer Mailbox.",
    "saved.count": "{n} gespäichert",
    "saved.totalNew": "{n} nei Annoncen zënter Ärem leschte Besuch",
    "saved.new": "{n} nei",
    "saved.noNew": "Näischt Neies",
    "saved.freq.instant": "Direkt",
    "saved.freq.daily": "Deeglech Zesummefaassung",
    "saved.freq.off": "Aus",
    "saved.freq.instantHint": "E-Mail soubal eng nei Annonce passt (max. eng pro Stonn)",
    "saved.freq.dailyHint": "Eng Zesummefaassung all Moien um 8.00 Auer",
    "saved.freq.offHint": "Keng E-Mailen, nëmmen de Badge op dëser Säit",
    "saved.view": "Resultater kucken",
    "saved.rename": "Ëmbenennen",
    "saved.delete": "Läschen",
    "saved.deleteTitle": "Dës gespäichert Sich läschen?",
    "saved.deleteText": "Dir kritt keng Alarmer méi fir „{name}“.",
    "saved.cancel": "Ofbriechen",
    "saved.empty": "Nach keng gespäichert Sichen",
    "saved.emptyText": "Start eng Sich, tippt op „Sich späicheren“ a mir mellen eis, wann eppes Neies passt.",
    "saved.startSearching": "Sichen ufänken",
    "saved.newSearch": "Nei Sich",
    "saved.updated": "Sich aktualiséiert",
    "saved.deleted": "Sich geläscht",
    "saved.failed": "Eppes ass schifgaang, probéiert w.e.g. nach eng Kéier",
    "saved.allListings": "All Annoncen",
    "saved.upTo": "Bis {n} €",
    "saved.from": "Vun {n} €",
    "saved.manage": "Sichen verwalten",
    "saved.signIn": "Loggt Iech an, fir Är gespäichert Sichen ze gesinn",
    "home.latest.forYou": "Fir Iech recommandéiert",
    "feed.notInterested": "Keen Interessi",
    "feed.hidden": "Mir weisen Iech manner esou Annoncen.",
    "feed.undo": "Réckgängeg",
    "feed.why.similar_to_favourites": "Ähnlech wéi Är Favoritten",
    "feed.why.viewed_subcategory": "Well Dir ähnlech Artikele gekuckt hutt",
    "feed.why.favourite_category": "Aus enger Kategorie, déi Dir verfollegt",
    "feed.why.near_you": "An Ärer Géigend",
    "feed.why.new_and_popular": "Nei a populär",
    "feed.why.explore": "Mol eppes aneres",
    "profile.personalization": "Personaliséiert Recommandatiounen",
    "profile.personalizationHint": "Meng Opruffe, Favoritten, Sichen a Messagen notzen, fir d'Startsäit fir mech ze sortéieren. Aus = dee selwechte Feed wéi fir jiddereen.",
    "profile.clearHistory": "Mäi Recommandatiounsverlaf läschen",
    "phoneVerify.badgeHint": "Dëse Member huet per SMS-Code bestätegt, datt en eng Handysnummer kontrolléiert. Dat ass keng Identitéitskontroll a garantéiert keng Transaktioun.",
    "phoneVerify.title": "Är Telefonsnummer bestätegen",
    "phoneVerify.subtitle": "Fir d'Sécherheet vun jidderengem bestätegt all Member eemol eng Handysnummer, ier en Messagen schéckt. Mir schécken nëmmen e Code per SMS — Är Nummer bleift privat.",
    "phoneVerify.phoneLabel": "Handysnummer",
    "phoneVerify.sendCode": "Code schécken",
    "phoneVerify.sending": "Gëtt geschéckt…",
    "phoneVerify.codeSentTo": "Mir hunn e 6-stellege Code geschéckt un",
    "phoneVerify.codeLabel": "Code aginn",
    "phoneVerify.verify": "Bestätegen",
    "phoneVerify.verifying": "Gëtt gepréift…",
    "phoneVerify.resend": "Code nach eng Kéier schécken",
    "phoneVerify.resendIn": "Nach eng Kéier an {s}s",
    "phoneVerify.changeNumber": "Nummer änneren",
    "phoneVerify.successTitle": "Telefon bestätegt",
    "phoneVerify.successText": "Merci! Dir kënnt elo mat Keefer a Verkeefer schreiwen.",
    "phoneVerify.continue": "Weider",
    "phoneVerify.required": "Bestätegt w.e.g. Är Telefonsnummer fir Messagen ze schécken.",
    "phoneVerify.mockHint": "Testmodus: Code 123456 benotzen",
    "phoneVerify.verifyButton": "Mäin Telefon bestätegen",
    "phoneVerify.verifiedLabel": "Telefon bestätegt",
    "phoneVerify.notVerifiedLabel": "Telefon net bestätegt",
    "phoneVerify.err.invalid_phone": "Dës Telefonsnummer ass net valabel.",
    "phoneVerify.err.country_not_allowed": "Nëmmen Nummeren aus Lëtzebuerg, Frankräich, Belsch, Däitschland, Portugal, Italien a Spuenien ginn akzeptéiert.",
    "phoneVerify.err.mobile_required": "Benotzt w.e.g. eng Handysnummer.",
    "phoneVerify.err.phone_already_used": "Dës Nummer ass schonn op engem anere Kont bestätegt.",
    "phoneVerify.err.incorrect_code": "Falsche Code. Nach {n} Versich.",
    "phoneVerify.err.expired": "Dëse Code ass ofgelaf. Frot en neien un.",
    "phoneVerify.err.attempts_exhausted": "Ze vill Versich. Frot en neie Code un.",
    "phoneVerify.err.resend_cooldown": "Waart w.e.g. e Moment, ier Dir en neie Code ufrot.",
    "phoneVerify.err.provider_error": "D'SMS konnt de Moment net geschéckt ginn. Probéiert et gläich nach eng Kéier.",
    "phoneVerify.err.generic": "Eppes ass schifgaang. Probéiert et w.e.g. nach eng Kéier.",
    "profile.standard": "Standard",
    "category.byCity": "No Stad duerchsichen",
    "home.latest.discover": "Recommandéiert",
    "filters.moreCriteria": "Méi Critèren ({count})",
    "filters.lessCriteria": "Manner Critèren",
    "auth.register.err.emailExists": "Dës E-Mail ass schonn registréiert. Probéiert Iech unzemellen.",
    "edit.title": "Annonce änneren",
    "edit.basicDetails": "Haaptinformatiounen",
    "edit.saving": "Gëtt gespäichert...",
    "edit.success": "Annonce aktualiséiert!",
    "edit.err.load": "D'Annonce konnt net geluede ginn",
    "edit.err.update": "D'Annonce konnt net aktualiséiert ginn. Probéiert w.e.g. nach eng Kéier.",
    "auth.register.subtitle": "Erstellt e Kont, fir ze kafen an ze verkafen.",
    "auth.register.passwordPlaceholder": "Passwuert erstellen",
    "auth.register.req.length": "Mindestens 8 Zeechen",
    "auth.register.req.upper": "Ee Groussbuschtaf",
    "auth.register.req.number": "Eng Zuel",
    "auth.register.err.terms": "Akzeptéiert w.e.g. d'Notzungsbedingungen",
    "auth.register.err.password": "D'Passwuert erfëllt net all Ufuerderungen",
    "auth.register.err.failed": "Aschreiwung feelgeschloen. Probéiert w.e.g. nach eng Kéier.",
    "auth.register.err.google": "Google-Aschreiwung feelgeschloen",
    "auth.register.agree": "Ech akzeptéieren d'",
    "auth.register.termsLink": "Notzungsbedingungen",
    "auth.register.and": "an d'",
    "auth.register.privacyLink": "Dateschutzerklärung",
    "auth.register.creating": "Kont gëtt erstallt...",
    "auth.login.err.invalid": "E-Mail oder Passwuert falsch",
    "auth.login.err.google": "Google-Umeldung feelgeschloen",
    "listing.ownerActions": "Är Annonce verwalten",
    "myListings.actions.markSold": "Als verkaaft markéieren",
    "myListings.actions.reactivate": "Reaktivéieren",
    "myListings.views": "Opruffen",
    "myListings.sold.title": "Als verkaaft markéieren?",
    "myListings.sold.text": "„{title}“ gëtt als verkaaft ugewisen. Gespréicher ouni ugeholl Offer ginn zougemaach. Dir kënnt d'Annonce spéider reaktivéieren.",
    "myListings.toast.sold": "Annonce als verkaaft markéiert",
    "myListings.toast.deleted": "Annonce geläscht",
    "myListings.toast.reactivated": "Annonce reaktivéiert",
    "myListings.toast.failed": "Aktioun feelgeschloen, probéiert w.e.g. nach eng Kéier",
    // Header
    "header.categories": "Kategorien",
    "header.searchPlaceholder": "Artikele sichen...",
    "header.login": "Umellen",
    "header.signup": "Registréieren",
    "header.sell": "Verkafen",
    "header.favorites": "Favoritten",
    "header.messages": "Noriichten",
    "header.myListings": "Meng Annoncen",
    "header.profile": "Profil",
    "header.logout": "Ausloggen",
    "header.tagline": "Lëtzebuerg & Ëmgéigend | Lokal kafen a verkafen am Ëmkrees vu 200km",
    
    // Navigation
    "nav.categories": "Kategorien",
    "nav.sell": "En Artikel verkafen",
    "nav.logout": "Ausloggen",
    "nav.myProfile": "Mäi Profil",
    "nav.myListings": "Meng Annoncen",
    "nav.favorites": "Favoritten",
    "nav.messages": "Noriichten",
    "nav.login": "Umellen",
    "nav.signup": "Registréieren",
    "cond.new-with-tags": "Nei mat Etikett",
    "cond.excellent": "Exzellent",
    "cond.very-good": "Ganz gutt",
    "cond.used": "Gebraucht",
    "filters.details": "Detailer",
    "filters.min": "Min",
    "filters.max": "Max",
    "filters.priceRange": "Präis",
    "filters.anyCondition": "All Zoustänn",
    "profile.tabSaved": "Gespäichert Annoncen",
    "profile.tabSearches": "Gespäichert Sichen",
    "profile.tabSettings": "Astellungen",
    "messages.sendFailed": "Är Noriicht konnt net geschéckt ginn. Probéiert w.e.g. nach eng Kéier.",
    "messages.searchPlaceholder": "Gespréicher sichen…",
    "messages.markAllRead": "Alles als gelies markéieren",
    "filters.category": "Kategorie",
    "filters.allCategories": "All Kategorien",
    "filters.subcategory": "Ënnerkategorie",
    "filters.allSubcategories": "All Ënnerkategorien",
    "filters.condition": "Zoustand",
    "filters.location": "Standuert",
    "filters.yourLocation": "Är Positioun",
    "filters.transaction": "Transaktiounsaart",
    "filters.saleOrRent": "Verkaf oder Locatioun",
    "filters.any": "Egal",
    "filters.forSale": "Ze verkafen",
    "filters.forRent": "Ze lounen",
    "filters.realEstate": "Immobilie-Filter",
    "filters.vehicles": "Gefier-Filter",
    "filters.surface": "Fläch (m²)",
    "filters.minRooms": "Zëmmer min.",
    "filters.brand": "Mark",
    "filters.anyBrand": "All Marken",
    "filters.year": "Joer (vun)",
    "filters.anyYear": "All Joren",
    "filters.mileage": "Max. Kilometer",
    "filters.anyMileage": "All Kilometer",
    "filters.fuel": "Brennstoff",
    "filters.anyFuel": "All Brennstoffer",
    "filters.search": "Sichen",
    "filters.saveSearch": "Sich späicheren",
    "filters.saveFailed": "D'Sich konnt net gespäichert ginn. Probéiert nach eng Kéier.",
    "filters.list": "Lëscht",
    "filters.map": "Kaart",
    "filters.searchName": "Numm vun der Sich",
    "filters.searchNamePlaceholder": "z. B. Appartementer ënner 1.500 €",
    "filters.emailAlerts": "E-Mail-Alerten",
    "filters.emailAlertsHint": "Gitt informéiert wann nei Annoncen passen",
    "cond.new": "Nei",
    "cond.like-new": "Wéi nei",
    "cond.good": "Gutt",
    "cond.fair": "Akzeptabel",
    "cond.poor": "Gebraucht",
    "category.notFound": "Kategorie net fonnt",
    "category.notFoundText": "Dës Kategorie gëtt et net.",
    "category.backHome": "Zréck op d'Startsäit",
    "category.empty": "Keng Annoncen an dëser Kategorie",
    "myListings.signIn": "Loggt Iech an fir Är Annoncen ze gesinn",
    "myListings.signInText": "Verwalt all Är Annoncen op enger Plaz",
    "myListings.shipping": "Liwwerung",
    "auth.signIn": "Aloggen",
    "footer.serving": "Aktiv an:",
    "footer.howItWorks": "Wéi et funktionéiert",
    "footer.faq": "FAQ",
    "footer.aboutUs": "Iwwer eis",
    "footer.careers": "Karriär",
    "country.luxembourg": "Lëtzebuerg",
    "country.germany": "Däitschland",
    "country.france": "Frankräich",
    "country.belgium": "Belsch",
    "profile.logout": "Ausloggen",
    "profile.noSaved": "Nach keng gespäichert Annoncen",
    "profile.noSavedText": "Späichert Annoncen iwwer d'Häerz-Symbol",
    "profile.noSearches": "Nach keng gespäichert Sichen",
    "profile.notifications": "Notifikatiounen",
    "profile.notificationsText": "Wielt wéi Dir informéiert gitt",
    "profile.emailNotifications": "E-Mail-Notifikatiounen",
    "profile.accountInfo": "Kontinformatiounen",
    "profile.accountInfoText": "Är Kontodaten",
    "profile.email": "E-Mail",
    "profile.accountStatus": "Kontostatus",
    "explore.savedSearches": "Är gespäichert Sichen",
    "search.trending": "Populär Sichen",
    "search.recentlyViewed": "Viru kuerzem gekuckt",
    "search.clearRecent": "Läschen",
    "messages.repliesIn": "Äntwert an {time}",
    "messages.replyRateShort": "{rate} % Äntwertquot",
    "messages.memberSince": "Member zënter {date}",
    "nav.allCategories": "All Kategorien",
    "nav.admin": "Admin",
    "browser.viewAll": "Alles an {name} kucken",
    "browser.ads": "Annoncen",
    "browser.ad": "Annonce",
    
    // Homepage
    "home.hero.title": "Kafen & Verkafen zu",
    "home.hero.highlight": "Lëtzebuerg & Ëmgéigend",
    "home.hero.subtitle": "Lokal kafen a verkafen zu Lëtzebuerg an an den Nopeschstied. Gratis Annoncen, 4 Sproochen, Iwwergab op der Plaz.",
    "home.search.placeholder": "Wat sicht Dir?",
    "home.search.allLocations": "All Plazen",
    "home.search.button": "Sichen",
    "home.search.minPrice": "Min €",
    "home.search.maxPrice": "Max €",
    "home.search.filters": "Filteren",
    "home.search.advanced": "Erweidert Sich",
    "home.search.clearFilters": "Filteren läschen",
    "home.search.applyFilters": "Uwenden",
    "home.search.clearAll": "Alles läschen",
    "home.search.filterBy": "Filtere no",
    "home.search.selectOption": "Auswielen",
    "home.search.all": "All",
    "home.search.results": "Resultater",
    "home.search.resultsIn": "zu",
    "home.popular": "Beléift:",
    
    // Map Search
    "mapSearch.title": "Immobilie Sich",
    "mapSearch.propertiesFound": "Immobilie fonnt",
    "mapSearch.onMap": "op der Kaart",
    "mapSearch.map": "Kaart",
    "mapSearch.list": "Lëscht",
    "mapSearch.filters": "Filteren",
    "mapSearch.listingType": "Annonce Typ",
    "mapSearch.propertyType": "Immobilie Typ",
    "mapSearch.price": "Präis",
    "mapSearch.minRooms": "Minimum Zëmmeren",
    "mapSearch.all": "All",
    "mapSearch.forSale": "Ze verkafen",
    "mapSearch.forRent": "Ze lounen",
    "mapSearch.anyRooms": "Egal",
    "mapSearch.resetFilters": "Zrécksetzen",
    "mapSearch.viewListing": "Annonce kucken",
    "mapSearch.noProperties": "Keng Immobilie fonnt",
    "common.loading": "Lueden...",
    
    "home.cta.title": "Zäit fir ze verkafen!",
    "home.cta.subtitle": "Setzt Är Annonce gratis an erreeche Dausende vu Keefer",
    "home.cta.button": "Annonce opginn",
    "home.noResults.title": "Keng Annoncen fonnt",
    "home.noResults.subtitle": "Keng Annoncen entspriechen Ären Critèren",
    "home.noResults.beFirst": "Sidd dén Éischten deen eng Annonce verëffentlecht!",
    "home.stats.listings": "Aktiv Annoncen",
    "home.stats.users": "Registréiert Memberen",
    "home.stats.countries": "Länner",
    "home.mapSearch": "Kaartesich",
    "home.viewOnMap": "Op Kaart kucken",
    "home.map": "Kaart",
    "home.categories.title": "No Kategorie browsen",
    "home.categories.viewAll": "All weisen",
    "home.featured.title": "Recommandéiert Annoncen",
    "home.featured.seeAll": "All weisen",
    "home.latest.title": "Recommandéiert Annoncen",
    "home.latest.category": "Kategorie",
    "home.latest.newest": "Neisten als éischt",
    "home.latest.priceLow": "Präis: Niddregsten",
    "category.listingsFound": "{count} Annoncen fonnt",
    "category.noListingsFound": "Keng Annoncen an dëser Kategorie fonnt",
    "category.loadMore": "Méi Annoncen lueden",
    "category.all": "All",
    "category.allConditions": "All Zoustänn",
    "category.condition": "Zoustand",
    "category.filters": "Filteren",
    "category.clearAll": "Alles läschen",
    "category.clearAllFilters": "All Filteren läschen",
    "category.clearFilters": "Filteren läschen",
    "sort.newest": "Neist zuerst",
    "sort.priceLow": "Präis: Néideg op Héich",
    "sort.priceHigh": "Präis: Héich op Néideg",
    "sort.popular": "Am beléifsten",
    "sort.oldest": "Eelst zuerst",
    "sort.label": "Sortéieren no",
    "followup.label": "Kuerz nogefrot",
    "followup.yes": "Jo, nach ëmmer interesséiert",
    "followup.no": "Nee, merci",
    "followup.answeredYes": "Är Äntwert: nach ëmmer interesséiert 👍",
    "followup.answeredNo": "Är Äntwert: net méi interesséiert",
    "followup.sellerHint": "Mir hunn de Keefer gefrot, ob hien nach interesséiert ass.",
    "sold.prompt.title": "Offer ugeholl!",
    "sold.prompt.description": "„{title}“ als verkaaft markéieren? Aner Keefer ginn informéiert, dëse Chat bleift fir d'Iwwergab op.",
    "sold.prompt.hint": "D'Annonce bleift 30 Deeg mam Badge „Verkaaft“ siichtbar.",
    "sold.prompt.confirm": "Als verkaaft markéieren",
    "sold.prompt.later": "Méi spéit",
    "sold.prompt.done": "Annonce als verkaaft markéiert 🎉",
    "sold.banner.text": "Dir hutt eng Offer fir „{title}“ ugeholl.",
    "sold.banner.cta": "Als verkaaft markéieren",
    "listing.sold": "Verkaaft",
    "messages.closedSold": "Gespréich zou — d'Annonce gouf verkaaft",
    "safety.nudge": "Bleift sécher: trefft Iech op enger ëffentlecher Plaz, bezuelt eréischt bei der Iwwergab, keng Acompte a keng Bezuelung ausserhalb vu LebonLux.",
    "home.latest.priceHigh": "Präis: Héchsten",
    "home.latest.popular": "Beléiftsten",
    "home.latest.loadMore": "Méi Annoncen lueden",
    "home.latest.noListings": "Keng Annoncen fonnt",
    "home.latest.createFirst": "Éischt Annonce erstellen",
    "home.why.title": "Firwat LebonLux?",
    "home.why.verified.title": "Verifizéiert Verkefer",
    "home.why.verified.desc": "Kaaft mat Vertrauen vu verifizéierte Verkefer mat Bewäertungen.",
    "home.why.local.title": "Lokal & grenziwwerschreidend",
    "home.why.local.desc": "Fannt Offeren zu Lëtzebuerg an den Nopeschregiounen a 4 Länner.",
    "home.why.ai.title": "KI-ënnerstëtzt Annoncen",
    "home.why.ai.desc": "Verkaf méi séier mat automatescher Kategoriséierung a Präisvirschléi.",
    
    // Categories
    "category.vehicules": "Gefierter",
    "category.immobilier": "Immobilien",
    "category.vacances": "Vakanzleiungen",
    "category.emploi": "Aarbechtsplazen",
    "category.mode": "Moud",
    "category.maison-jardin": "Haus & Gaart",
    "category.famille": "Famill",
    "category.electronique": "Elektronik",
    "category.loisirs": "Fräizäit",
    "category.services": "Servicer",
    "category.materiel-pro": "Profi-Ausrüstung",
    "category.art": "Konscht",
    "category.autres": "Anerer",
    "category.ads": "Annoncen",
    
    // Create Listing
    "create.title": "Annonce erstellen",
    "create.step.photos": "Fotoen",
    "create.step.details": "Detailer",
    "create.step.price": "Präis & Standuert",
    "create.step.confirm": "Bestätegen",
    "create.photos.title": "Fotoen derbäisetzen",
    "create.photos.subtitle": "Setzt bis zu 10 Fotoe bäi. Dat éischt Bild gëtt d'Titelbild.",
    "create.photos.upload": "Klickt fir eropzelueden",
    "create.photos.dragDrop": "oder dréckt a verréckelt",
    "create.photos.cover": "Titelbild",
    "create.photos.optional": "Fotoe sinn optional - Dir kënnt se méi spéit bäisetzen",
    "create.photos.skipAI": "Iwwersprangen a manuell kategoriséieren",
    "create.ai.title": "KI-ënnerstëtzt Ausfëllen",
    "create.ai.subtitle": "Loosst eis KI Är Fotoe analyséieren fir automatesch Kategorie, Titel, Beschreiwung a Präis virzeschloen.",
    "create.ai.analyze": "Fotoen analyséieren",
    "create.ai.analyzing": "Analyséiert...",
    "create.ai.category": "Virgeschloe Kategorie",
    "create.ai.titleSuggestion": "Virgeschloen Titel",
    "create.ai.retailValue": "Geschate Neipräis",
    "create.ai.suggestedPrice": "Empfohlene Verkafspräis",
    "create.ai.confidence": "Sécherheetsniveau",
    "create.ai.apply": "Virschléi iwwerhuelen",
    "create.ai.suggestPrice": "KI-Präis",
    "create.ai.calculating": "Berechent...",
    "create.ai.suggestedRange": "KI-empfohlene Präisspann",
    "create.ai.priceError": "Fëllt w.e.g. éischt Titel, Kategorie a Zoustand aus",
    "create.ai.priceSuggestionFailed": "KI-Präisvirschlag konnt net ofgeruff ginn. Gitt de Präis w.e.g. manuell an.",
    "create.details.title": "Artikel Detailer",
    "create.details.subtitle": "Beschreiwt Ären Artikel fir Keefer.",
    "create.details.itemTitle": "Titel",
    "create.details.titlePlaceholder": "z.B. iPhone 14 Pro - Excellent Zoustand",
    "create.details.description": "Beschreiwung",
    "create.details.descPlaceholder": "Beschreiwt Ären Artikel - Zoustand, Eegeschaften, Verkaafsgrond...",
    "create.details.category": "Kategorie",
    "create.details.selectCategory": "Kategorie auswielen",
    "create.details.subcategory": "Ënnerkategorie",
    "create.details.selectSubcategory": "Ënnerkategorie auswielen",
    "create.details.condition": "Zoustand",
    "create.details.selectCondition": "Zoustand auswielen",
    "create.details.attributes": "Zousätzlech Detailer",
    "create.price.title": "Präis & Standuert",
    "create.price.subtitle": "Setzt Äre Präis an bestätegt Äre Standuert.",
    "create.price.type": "Präis Typ",
    "create.price.fixed": "Festpräis",
    "create.price.negotiable": "Verhandelbar",
    "create.price.free": "Gratis",
    "create.price.amount": "Präis (€)",
    "create.price.retailHint": "Neipräis: {value} €",
    "create.location.title": "Standuert",
    "create.location.select": "Wielt Äre Standuert",
    "create.location.change": "Änneren",
    "create.shipping.title": "Liwwerung disponibel",
    "create.shipping.subtitle": "Bitt Liwwerung un Keefer un",
    "create.preview": "Virschau",
    "create.preview.title": "Ären Annonce Titel",
    "create.preview.selectLocation": "Standuert auswielen",
    "create.nav.back": "Zréck",
    "create.nav.continue": "Weider",
    "create.nav.publish": "Annonce verëffentlechen",
    "create.nav.publishing": "Gëtt verëffentlecht...",
    "create.location.popup.title": "Wou sidd Dir?",
    "create.location.popup.detect": "Mäin aktuelle Standuert benotzen",
    "create.location.popup.detecting": "Standuert gëtt ermëttelt...",
    "create.location.popup.manual": "Oder manuell aginn",
    "create.location.popup.search": "Stad oder Duerf sichen...",
    "create.location.popup.hint": "Mir bedéngen Lëtzebuerg an d'Regiounen am Ëmkrees vu 200km",
    
    // Confirm Step
    "create.confirm.title": "Är Annonce iwwerpréiwen",
    "create.confirm.subtitle": "Préift w.e.g. all Detailer virum Verëffentlechen. Dir kënnt all Feld änneren.",
    "create.confirm.noPhotos": "Keng Fotoe bäigesat",
    "create.confirm.editPhotos": "Fotoen änneren",
    "create.confirm.preview": "Annonce Virschau",
    
    // My Listings
    "myListings.title": "Meng Annoncen",
    "myListings.count": "{count} aktiv Annoncen",
    "myListings.newListing": "Nei Annonce",
    "myListings.empty.title": "Nach keng Annoncen",
    "myListings.empty.subtitle": "Fänkt un ze verkafen andeems Dir Är éischt Annonce erstellt",
    "myListings.empty.button": "Éischt Annonce erstellen",
    "myListings.actions.view": "Kucken",
    "myListings.actions.edit": "Änneren",
    "myListings.actions.delete": "Läschen",
    "myListings.delete.title": "Annonce läschen",
    "myListings.delete.whyDelete": "Firwat läscht Dir dës Annonce?",
    "myListings.delete.confirm": "Sidd Dir sécher datt Dir \"{title}\" läsche wëllt? Dës Aktioun kann net réckgängeg gemaach ginn.",
    "myListings.delete.cancel": "Ofbriechen",
    "myListings.delete.deleting": "Gëtt geläscht...",
    "myListings.delete.markingSold": "Gëtt als verkaf markéiert...",
    "myListings.delete.markSold": "Als verkaf markéieren",
    "myListings.delete.otherPlaceholder": "Gitt w.e.g. de Grond un...",
    "myListings.delete.congrats": "Gratulatioun zum Verkaf! Merci datt Dir LebonLux benotzt.",
    "myListings.deleteReason.soldHere": "Op LebonLux verkaf",
    "myListings.deleteReason.soldElsewhere": "Anerwäerts verkaf",
    "myListings.deleteReason.noLongerSelling": "Wëll net méi verkafen",
    "myListings.deleteReason.other": "Anere Grond",
    
    // Favorites
    "favorites.title": "Meng Favoritten",
    "favorites.savedItems": "gespäichert Artikelen",
    "favorites.signIn": "Mellt Iech un fir Är Favoritten ze gesinn",
    "favorites.signInSubtitle": "Späichert Artikelen déi Dir gär hutt a kommt ëmmer zréck",
    "favorites.empty": "Nach keng Favoritten",
    "favorites.emptySubtitle": "Fänkt un Artikelen ze späicheren andeems Dir op d'Häerz klickt",
    "favorites.browse": "Annoncen duerchsichen",
    
    // Profile
    "profile.signInRequired": "Mellt Iech un fir Äre Profil ze gesinn",
    "profile.editProfile": "Profil änneren",
    "profile.verified": "Telefon bestätegt",
    "profile.basicInfo": "Basis Informatiounen",
    "profile.name": "Numm",
    "profile.phone": "Telefonsnummer",
    "search.noResultsFor": "Keng Resultater fir « {q} »",
    "search.noListings": "Keng Annoncen",
    "search.tryDifferent": "Probéiert aner Wierder oder Filter",
    "search.clearFilters": "Filter läschen",
    "search.searching": "Sichen…",
    "search.items": "{n} Annoncen",
    "badge.new": "Nei",
    "badge.priceDrop": "Präis gesenkt",
    "badge.shipping": "Liwwerung méiglech",
    "badge.saves": "{n}× gespäichert",
    "badge.savesLong": "{n} Leit hunn dës Annonce gespäichert",
    "alerts.title": "Wéineg Resultater? Gitt informéiert",
    "alerts.text": "Mir schécken Iech eng E-Mail soubal eng nei Annonce op dës Sich passt.",
    "alerts.cta": "Alarm erstellen",
    "alerts.created": "Alarm erstallt — mir informéieren Iech iwwer nei Annoncen",
    "alerts.exists": "Dir hutt schonn en Alarm fir dës Sich",
    "alerts.manage": "Meng Alarmer",
    "alerts.login": "Loggt Iech an fir den Alarm ze erstellen — Är Sich bleift gespäichert",
    "profile.replyRate": "Äntwertquote",
    "profile.replyTime": "Äntwert an",
    "profile.stats.sold": "Verkaaft",
    "buyer.contact": "Verkeefer kontaktéieren",
    "buyer.contactPrice": "Verkeefer kontaktéieren • {price}",
    "buyer.send": "Message schécken",
    "buyer.dialogTitle": "Dem Verkeefer schreiwen",
    "buyer.messagePlaceholder": "Moien, ass den Artikel nach disponibel?",
    "buyer.quick.available": "Nach disponibel?",
    "buyer.quick.lastPrice": "Leschte Präis?",
    "buyer.quick.visit": "Kann ech laanscht kommen?",
    "buyer.quick.delivery": "Liwwerung méiglech?",
    "buyer.offer.cta": "Eng Offer maachen",
    "buyer.offer.title": "Är Offer",
    "buyer.offer.hint": "De Verkeefer kann am Chat unhuelen oder refuséieren.",
    "buyer.offer.send": "Offer vu {amount} € schécken",
    "buyer.offer.accept": "Unhuelen",
    "buyer.offer.decline": "Refuséieren",
    "buyer.offer.pending": "Offer oppen",
    "buyer.offer.accepted": "Offer ugeholl",
    "buyer.offer.declined": "Offer refuséiert",
    "buyer.offer.yours": "Är Offer",
    "buyer.sentToast": "Message geschéckt — de Verkeefer gouf informéiert",
    "buyer.savedDraft": "Loggt Iech an, fir de Message ze schécken — mir hunn en gespäichert",
    "buyer.seller.replyRate": "Äntwertquote",
    "buyer.seller.replyTime": "Äntwert an",
    "buyer.seller.listings": "Annoncen",
    "buyer.seller.memberSince": "Member zanter {date}",
    "buyer.seller.call": "Verkeefer uruffen",
    "buyer.seller.replyMinutes": "~{n} Min",
    "buyer.seller.replyHours": "~{n} St",
    "buyer.seller.replyDays": "~{n} D",
    "buyer.seller.safety": "Trefft Iech op enger ëffentlecher Plaz a bezuelt eréischt wann Dir den Artikel an der Hand hutt. Ni eng Akonto schécken.",
    "auth.sheet.title": "Aloggen fir weiderzefueren",
    "auth.sheet.description": "Dauert 10 Sekonnen. Äre Message bleift gespäichert a gëtt duerno geschéckt.",
    "auth.sheet.google": "Mat Google weiderfueren",
    "auth.sheet.emailPlaceholder": "Är E-Mail",
    "auth.sheet.passwordPlaceholder": "Passwuert",
    "auth.sheet.magic": "Login-Link schécken",
    "auth.sheet.login": "Aloggen",
    "auth.sheet.usePassword": "Ech hunn e Passwuert",
    "auth.sheet.useMagic": "Ouni Passwuert aloggen",
    "auth.sheet.magicSentTitle": "Kuckt an Är Mailbox",
    "auth.sheet.magicSentText": "Mir hunn e Login-Link op {email} geschéckt. Maacht en op dësem Telefon op.",
    "auth.sheet.noAccountHint": "Nach kee Kont? E gëtt automatesch erstallt.",
    "auth.sheet.error": "Eppes ass schifgaang, probéiert w.e.g. nach eng Kéier",
    "nav.home": "Start",
    "nav.search": "Sichen",
    "nav.sell": "Verkafen",
    "nav.messages": "Messagen",
    "nav.profile": "Profil",
    "nav.login": "Aloggen",
    "card.noPhoto": "Keng Foto",
    "filters.title": "Filter",
    "filters.priceRange": "Präisspann (€)",
    "filters.anyCondition": "All Zoustänn",
    "filters.includeSold": "Verkaaften Artikelen weisen",
    "filters.nearMe": "Annoncen bei mir",
    "filters.locating": "Standuert gëtt gesicht…",
    "filters.show": "{n} Resultater weisen",
    "filters.searchPlaceholder": "Sichen…",
    "filters.allListings": "All Annoncen",
    "filters.newest": "Neist fir d’éischt",
    "filters.cityPlaceholder": "Stad oder Gemeng…",
    "messages.typePlaceholder": "Message schreiwen…",
    "messages.makeOffer": "Offer maachen",
    "messages.viewListing": "Annonce kucken",
    "profile.saved": "Profil aktualiséiert",
    "profile.saveFailed": "Profil konnt net gespäichert ginn",
    "profile.showPhonePublic": "Telefonsnummer a mengen Annoncen weisen",
    "profile.bio": "Iwwer mech",
    "profile.bioPlaceholder": "Erzielt aneren iwwer Iech...",
    "profile.location": "Standuert",
    "profile.city": "Stad",
    "profile.country": "Land",
    "profile.professionalAccount": "Professionelle Kont",
    "profile.companyName": "Firmeninumm",
    "profile.siret": "SIRET Nummer",
    "profile.website": "Websäit",
    "profile.responseTime": "Äntwertzäit",
    "profile.selectResponseTime": "Wielt Är typesch Äntwertzäit",
    "profile.notSpecified": "Net uginn",
    "profile.responseTime.1hour": "Manner wéi eng Stonn",
    "profile.responseTime.24hours": "Manner wéi 24 Stonnen",
    "profile.responseTime.2days": "1-2 Deeg",
    "profile.responseTime.moreDays": "Méi wéi 2 Deeg",
    "profile.memberSince": "Member zënter",
    "profile.responds": "Äntwert bannent",
    "profile.visitWebsite": "Websäit besichen",
    "profile.listings": "Annoncen",
    "profile.reviews": "Bewäertungen",
    "profile.responseRate": "Äntwertquot",
    "profile.myListings": "Meng Annoncen",
    "profile.reviewsTab": "Bewäertungen",
    "profile.newListing": "Nei Annonce",
    "profile.noListings": "Nach keng Annoncen",
    "profile.noListingsDesc": "Fänkt un ze verkafen andeems Dir Är éischt Annonce erstellt",
    "profile.createListing": "Annonce erstellen",
    "profile.noReviews": "Nach keng Bewäertungen",
    "profile.noReviewsDesc": "Bewäertungen erschéngen hei wann Keefer Feedback hannerloossen",
    "profile.reviewsComingSoon": "Bewäertungsfunktioun kënnt geschwënn",
    "profile.lastActive.unknown": "Kierzlech gesinn",
    "profile.lastActive.now": "Elo online",
    "profile.lastActive.hoursAgo": "Lescht gesinn viru",
    "profile.lastActive.yesterday": "Gëschter gesinn",
    "profile.lastActive.daysAgo": "Lescht gesinn viru",
    
    // Common
    "common.cancel": "Ofbriechen",
    "common.saving": "Späichert...",
    "common.saveChanges": "Ännerungen späicheren",
    "common.loading": "Lueden...",
    "common.sending": "Gëtt geschéckt...",
    "common.error": "E Feeler ass opgetrueden",
    "common.retry": "Erëm probéieren",
    "common.save": "Späicheren",
    "common.delete": "Läschen",
    "common.edit": "Änneren",
    "common.close": "Zoumaachen",
    "common.yes": "Jo",
    "common.no": "Nee",
    "common.free": "Gratis",
    "common.negotiable": "Verhandelbar",
    "common.today": "Haut",
    "common.yesterday": "Gëschter",
    "common.daysAgo": "viru {days} Deeg",
    "common.justNow": "Grad elo",
    "common.hoursAgo": "viru {hours}h",
    
    // Messages
    "messages.title": "Noriichten",
    "messages.search": "Gespréicher sichen...",
    "messages.signIn": "Mellt Iech un fir Noriichten ze gesinn",
    "messages.noConversations": "Nach keng Gespréicher",
    "messages.startConversation": "Fänkt e Gespréich un andeems Dir e Verkefer kontaktéiert",
    "messages.selectConversation": "Wielt e Gespréich",
    "messages.chooseConversation": "Wielt aus Ären existéierende Gespréicher oder fänkt en neit un",
    "messages.usuallyResponds": "Äntwert normalerweis bannent enger Stonn",
    "messages.report": "Mellen",
    "messages.deleteConversation": "Gespréich läschen",
    "messages.typePlaceholder": "Schreift eng Noriicht...",
    "messages.attachFile": "Fichier unhänken",
    "messages.attachImage": "Bild unhänken",
    
    // Auth
    "auth.login.title": "Wëllkomm zréck! Mellt Iech un fir weiderzemaachen.",
    "auth.login.google": "Mat Google weider",
    "auth.login.or": "oder",
    "auth.login.email": "E-Mail",
    "auth.login.emailPlaceholder": "är@email.com",
    "auth.login.password": "Passwuert",
    "auth.login.forgot": "Passwuert vergiess?",
    "auth.login.button": "Umellen",
    "auth.login.noAccount": "Kee Kont?",
    "auth.login.signup": "Registréieren",
    "auth.register.title": "Erstellt Äre Kont",
    "auth.register.name": "Vollstännegen Numm",
    "auth.register.namePlaceholder": "Numm Familljennumm",
    "auth.register.button": "Kont erstellen",
    "auth.register.hasAccount": "Schonn e Kont?",
    "auth.register.login": "Umellen",
    "auth.register.terms": "Mat der Registréierung akzeptéiert Dir eis AGB an Dateschutzrichtlinn",
    "auth.email": "E-Mail",
    "auth.emailPlaceholder": "är@email.com",
    
    // Forgot Password
    "forgot.title": "Passwuert vergiess?",
    "forgot.subtitle": "Gitt Är E-Mail an a mir schécken Iech e Link fir Äert Passwuert zréckzesetzen.",
    "forgot.sendLink": "Link schécken",
    "forgot.sending": "Gëtt geschéckt...",
    "forgot.backToLogin": "Zréck zur Umeldung",
    "forgot.success.title": "Préift Är E-Mail",
    "forgot.success.message": "Wann e Kont mat dëser E-Mail existéiert, hu mir Iech e Link geschéckt.",
    "forgot.success.checkSpam": "Net fonnt? Préift Äre Spam-Dossier.",
    
    // Reset Password
    "reset.title": "Passwuert zrécksetzen",
    "reset.subtitle": "Gitt Äert neit Passwuert an fir",
    "reset.newPassword": "Neit Passwuert",
    "reset.newPasswordPlaceholder": "Neit Passwuert aginn",
    "reset.confirmPassword": "Passwuert bestätegen",
    "reset.confirmPasswordPlaceholder": "Neit Passwuert bestätegen",
    "reset.resetButton": "Zrécksetzen",
    "reset.resetting": "Gëtt zréckgesat...",
    "reset.verifying": "Link gëtt iwwerpréift...",
    "reset.passwordMismatch": "Passwierder stëmmen net iwwerän",
    "reset.passwordTooShort": "Passwuert muss mindestens 6 Zeechen hunn",
    "reset.invalidToken.title": "Ongëltegen oder ofgelafene Link",
    "reset.invalidToken.message": "Dëse Link ass ongëlteg oder ofgelaf. Frot w.e.g. en neien un.",
    "reset.requestNewLink": "Neie Link ufroen",
    "reset.success.title": "Passwuert zréckgesat!",
    "reset.success.message": "Äert Passwuert gouf erfollegräich zréckgesat. Dir kënnt Iech elo umellen.",
    "reset.goToLogin": "Zur Umeldung",
    
    // Listing Detail
    "listing.contact": "Verkefer kontaktéieren",
    "listing.sendMessage": "Noriicht schécken",
    "listing.messagePlaceholder": "Moien, ech interesséiere mech fir dësen Artikel...",
    "listing.favorite": "Zu Favoritten bäisetzen",
    "listing.share": "Deelen",
    "listing.save": "Späicheren",
    "listing.report": "Annonce mellen",
    "listing.shipping": "Liwwerung disponibel",
    "listing.shippingPickupOnly": "Nëmmen Ofhuelen",
    "listing.condition": "Zoustand",
    "listing.location": "Standuert",
    "listing.posted": "Verëffentlecht",
    "listing.views": "Opruffen",
    "listing.saves": "Gespäichert",
    "listing.daysAgo": "Deeg hier",
    "listing.seller": "Verkefer",
    "listing.sellerInfo": "Verkefer Informatiounen",
    "listing.memberSince": "Member zënter",
    "listing.viewProfile": "Profil kucken",
    "listing.otherListings": "Aner Annoncen vun dësem Verkefer",
    "listing.similar": "Ähnlech Annoncen",
    "listing.description": "Beschreiwung",
    "listing.details": "Detailer",
    "listing.category": "Kategorie",
    "listing.subcategory": "Ënnerkategorie",
    "listing.safetyTips": "Sécherheetshinweiser:",
    "listing.safetyTip1": "Trëfft Iech an ëffentleche Plazen",
    "listing.safetyTip2": "Préift den Artikel virum Bezuelen",
    "listing.safetyTip3": "Bezuelt nëmmen nodeems Dir den Artikel hutt",
    "listing.reportListing": "Annonce mellen",
    "listing.translating": "Iwwersetzen...",
    "listing.translated": "Iwwersat",
    "listing.translate": "Iwwersetzen",
    "listing.noDescription": "Keng Beschreiwung uginn.",
    "listing.locationPrivacy": "Standuert op Stad/Uertsniveau fir Privatsphär",
    "listing.reviews": "Bewäertungen",
    "listing.verifiedSeller": "Verkeefer mat bestätegtem Telefon",
    "listing.soldMessage": "Dësen Artikel gouf verkaf",
    "listing.soldSubtext": "Kontakt- an Späicheroptiounen si net méi disponibel",
    
    // Report
    "report.title": "Mellen",
    "report.description": "Firwat mellt Dir dëst?",
    "report.listingDescription": "Firwat mellt Dir dës Annonce?",
    "report.reason.spam": "Spam oder irreféierend",
    "report.reason.inappropriate": "Onpassenden Inhalt",
    "report.reason.scam": "Betrug oder Schwindel",
    "report.reason.harassment": "Belästegung oder Mëssbrauch",
    "report.reason.counterfeit": "Gefälschten Artikel",
    "report.reason.other": "Aneren",
    "report.additionalInfo": "Zousätzlech Informatioun (optional)",
    "report.additionalPlaceholder": "Gitt méi Detailer iwwer dëse Bericht...",
    "report.submit": "Bericht ofschécken",
    "report.submitting": "Gëtt ofgeschéckt...",
    "report.success": "Bericht erfollegräich ofgeschéckt. Mir préiwen et geschwënn.",
    
    // Real Estate Details
    "realEstate.propertyDetails": "Immobilie Detailer",
    "realEstate.livingArea": "Wunnfläch",
    "realEstate.totalRooms": "Zuel vun Zëmmeren",
    "realEstate.bedrooms": "Schlofkummeren",
    "realEstate.bathrooms": "Buedzëmmeren",
    "realEstate.landArea": "Grondstécksfläch",
    "realEstate.pricePerSqm": "Präis pro m²",
    "realEstate.energyDiagnostics": "Energiediagnos",
    "realEstate.dpe": "Energieeffizienz (DPE)",
    "realEstate.ges": "Zäregasemissiounen (GES)",
    "realEstate.energyConsumption": "Energieverbrauchsklass",
    "realEstate.co2Emissions": "CO₂-Emissiounsklass",
    "realEstate.notSpecified": "Net uginn",
    "realEstate.energyNote": "Energieklassen beaflossen den Immobiliëwäert an d'Vermietbarkeet. Immobilie mat Klassen F oder G kënnen zu Lëtzebuerg a Frankräich Locatiounsbeschränkungen ënnerleien.",
    "realEstate.buildingInfo": "Gebai Informatiounen",
    "realEstate.floor": "Stack",
    "realEstate.yearBuilt": "Baujoer",
    "realEstate.heating": "Heizung",
    "realEstate.features": "Ausrüstung & Merkmooler",
    "realEstate.parking": "Parking",
    "realEstate.furnished": "Miwwléiert",
    "realEstate.balcony": "Balkon",
    "realEstate.terrace": "Terrass",
    "realEstate.garden": "Gaart",
    "realEstate.pool": "Pool",
    "realEstate.elevator": "Lift",
    "realEstate.cellar": "Keller",
    "realEstate.propertyType": "Immobilie Typ",
    
    // Footer
    "footer.about": "Iwwer LebonLux",
    "footer.aboutText": "LebonLux ass de féierende Maart fir Lëtzebuerg an d'Groussregioun, deen Keefer a Verkefer am Ëmkrees vu 200km verbënnt.",
    "footer.quickLinks": "Séier Linken",
    "footer.support": "Support",
    "footer.legal": "Rechtleches",
    "footer.contact": "Kontakt",
    "footer.help": "Hëllef-Center",
    "footer.safety": "Sécherheetshinweiser",
    "footer.terms": "Notzungsbedéngungen",
    "footer.privacy": "Dateschutz",
    "footer.cookies": "Cookie-Richtlinn",
    "footer.copyright": "© {year} LebonLux. All Rechter reservéiert.",
    // Säit net fonnt
    "notFound.title": "Säit net fonnt",
    "notFound.description": "D'Säit déi Dir sicht existéiert net oder gouf geréckelt.",
    "notFound.goHome": "Zréck op d'Haaptsäit",
    "notFound.browseListings": "Annoncen entdecken",
    "notFound.goBack": "Zréck",
    "listing.noReviewsYet": "Nach keng Bewäertungen",
    "search.seeAllFor": "All Resultater fir",
    "search.noSuggestions": "Keng Iwwerenstëmmungen. Probéiert déi voll Recherche:"
  }
};

export const languages = [
  { code: 'en', name: 'English', flag: '🇬🇧' },
  { code: 'fr', name: 'Français', flag: '🇫🇷' },
  { code: 'de', name: 'Deutsch', flag: '🇩🇪' },
  { code: 'lb', name: 'Lëtzebuergesch', flag: '🇱🇺' }
];

Object.keys(sellFlow).forEach((lang) => Object.assign(translations[lang], sellFlow[lang]));

export default translations;
